<template>
  <div>
    <svg viewBox="0 0 1000 1000"></svg>
  </div>
</template>

<script>
import AssetStorage from "../domain/storage/InMemoryStorage";

export default {
  mounted() {
    const cat = [
      {
        x1: 262.28254,
        y1: 670.81212,
        x2: 19.9069,
        y2: -11.43588,
        x3: -22.02465,
        y3: -32.61343,
        d: "m 262.28254,670.81212 19.9069,-11.43588 -22.02465,-32.61343",
        fill: "291639",
        r: 41,
        g: 22,
        b: 57,
      },
      {
        x1: 260.16479,
        y1: 626.76281,
        x2: -10.58877,
        y2: 25.83661,
        x3: 12.70652,
        y3: 18.2127,
        d: "m 260.16479,626.76281 -10.58877,25.83661 12.70652,18.2127",
        fill: "4d2d71",
        r: 77,
        g: 45,
        b: 113,
      },
      {
        x1: 280.60817,
        y1: 657.03473,
        x2: 7.4697,
        y2: -30.18731,
        x3: -27.91308,
        y3: -0.0847,
        d: "m 280.60817,657.03473 7.4697,-30.18731 -27.91308,-0.0847",
        fill: "47165e",
        r: 71,
        g: 22,
        b: 94,
      },
      {
        x1: 260.16479,
        y1: 626.76281,
        x2: 18.47768,
        y2: -35.18619,
        x3: 9.4354,
        y3: 35.2708,
        d: "m 260.16479,626.76281 18.47768,-35.18619 9.4354,35.2708",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 288.07787,
        y1: 626.76281,
        x2: 18.08452,
        y2: -27.71649,
        x3: -27.51992,
        y3: -7.4697,
        d: "m 288.07787,626.76281 18.08452,-27.71649 -27.51992,-7.4697",
        fill: "9c0a5f",
        r: 156,
        g: 10,
        b: 95,
      },
      {
        x1: 278.64247,
        y1: 591.57662,
        x2: 20.44336,
        y2: -31.64791,
        x3: -4.02105,
        y3: 36.10535,
        d: "m 278.64247,591.57662 20.44336,-31.64791 -4.02105,36.10535",
        fill: "8a1d55",
        r: 138,
        g: 29,
        b: 85,
      },
      {
        x1: 306.16239,
        y1: 599.04632,
        x2: 30.66506,
        y2: -16.11882,
        x3: -41.76267,
        y3: 13.10656,
        d: "m 306.16239,599.04632 30.66506,-16.11882 -41.76267,13.10656",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 299.08583,
        y1: 559.92871,
        x2: 37.74162,
        y2: 22.99879,
        x3: -41.76267,
        y3: 13.10656,
        d: "m 299.08583,559.92871 37.74162,22.99879 -41.76267,13.10656",
        fill: "a3066a",
        r: 163,
        g: 6,
        b: 106,
      },
      {
        x1: 320.93665,
        y1: 573.24364,
        x2: 55.0084,
        y2: -11.15264,
        x3: -39.1176,
        y3: 20.8365,
        d: "m 320.93665,573.24364 55.0084,-11.15264 -39.1176,20.8365",
        fill: "ba0a42",
        r: 186,
        g: 10,
        b: 66,
      },
      {
        x1: 299.08583,
        y1: 559.92871,
        x2: 27.12679,
        y2: -34.59647,
        x3: -5.27597,
        y3: 47.9114,
        d: "m 299.08583,559.92871 27.12679,-34.59647 -5.27597,47.9114",
        fill: "a0148e",
        r: 160,
        g: 20,
        b: 142,
      },
      {
        x1: 326.21262,
        y1: 525.33224,
        x2: 35.18618,
        y2: 12.97367,
        x3: -40.46215,
        y3: 34.93773,
        d: "m 326.21262,525.33224 35.18618,12.97367 -40.46215,34.93773",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 375.94505,
        y1: 562.091,
        x2: -14.54625,
        y2: -23.78509,
        x3: -40.46215,
        y3: 34.93773,
        d: "m 375.94505,562.091 -14.54625,-23.78509 -40.46215,34.93773",
        fill: "a6083d",
        r: 166,
        g: 8,
        b: 61,
      },
      {
        x1: 361.3988,
        y1: 538.39047,
        x2: 51.10844,
        y2: -0.0846,
        x3: -36.56219,
        y3: 23.78508,
        d: "m 361.3988,538.39047 51.10844,-0.0846 -36.56219,23.78508",
        fill: "e31b22",
        r: 227,
        g: 27,
        b: 34,
      },
      {
        x1: 361.3988,
        y1: 538.30591,
        x2: -11.40111,
        y2: -47.37358,
        x3: -23.78507,
        y3: 34.39991,
        d: "m 361.3988,538.30591 -11.40111,-47.37358 -23.78507,34.39991",
        fill: "a40f44",
        r: 164,
        g: 15,
        b: 68,
      },
      {
        x1: 355.35149,
        y1: 513.18101,
        x2: 57.15575,
        y2: 25.1249,
        x3: -51.10844,
        y3: 0.0846,
        d: "m 355.35149,513.18101 57.15575,25.1249 -51.10844,0.0846",
        fill: "c4161d",
        r: 196,
        g: 22,
        b: 29,
      },
      {
        x1: 349.99769,
        y1: 490.93233,
        x2: 24.76793,
        y2: -33.61362,
        x3: -19.41413,
        y3: 55.8623,
        d: "m 349.99769,490.93233 24.76793,-33.61362 -19.41413,55.8623",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 367.98943,
        y1: 476.8154,
        x2: 44.51781,
        y2: 61.49051,
        x3: -57.15575,
        y3: -25.1249,
        d: "m 367.98943,476.8154 44.51781,61.49051 -57.15575,-25.1249",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 437.34528,
        y1: 523.48321,
        x2: 28.03951,
        y2: -16.82521,
        x3: -97.39536,
        y3: -29.8426,
        d: "m 437.34528,523.48321 28.03951,-16.82521 -97.39536,-29.8426",
        fill: "f57c14",
        r: 245,
        g: 124,
        b: 20,
      },
      {
        x1: 374.76562,
        y1: 457.31871,
        x2: 32.11261,
        y2: 31.41282,
        x3: -38.8888,
        y3: -11.91613,
        d: "m 374.76562,457.31871 32.11261,31.41282 -38.8888,-11.91613",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 406.87823,
        y1: 488.73153,
        x2: 90.15447,
        y2: -15.7068,
        x3: -31.64791,
        y3: 33.63327,
        d: "m 406.87823,488.73153 90.15447,-15.7068 -31.64791,33.63327",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 465.38479,
        y1: 506.658,
        x2: 78.62836,
        y2: 19.08546,
        x3: -46.98045,
        y3: -52.71873,
        d: "m 465.38479,506.658 78.62836,19.08546 -46.98045,-52.71873",
        fill: "bfdf14",
        r: 191,
        g: 223,
        b: 20,
      },
      {
        x1: 544.01315,
        y1: 525.74346,
        x2: 34.20334,
        y2: 12.56245,
        x3: 31.25476,
        y3: -22.2125,
        d: "m 544.01315,525.74346 34.20334,12.56245 31.25476,-22.2125",
        fill: "3a6b98",
        r: 58,
        g: 107,
        b: 152,
      },
      {
        x1: 497.0327,
        y1: 473.02473,
        x2: 64.08211,
        y2: 26.35937,
        x3: -17.10166,
        y3: 26.35936,
        d: "m 497.0327,473.02473 64.08211,26.35937 -17.10166,26.35936",
        fill: "00a878",
        r: 0,
        g: 168,
        b: 120,
      },
      {
        x1: 609.47125,
        y1: 516.09341,
        x2: -28.69934,
        y2: -49.73244,
        x3: -19.6571,
        y3: 33.02313,
        d: "m 609.47125,516.09341 -28.69934,-49.73244 -19.6571,33.02313",
        fill: "0577b1",
        r: 5,
        g: 119,
        b: 177,
      },
      {
        x1: 374.76562,
        y1: 457.31871,
        x2: 91.41332,
        y2: 21.08105,
        x3: -59.30071,
        y3: 10.33177,
        d: "m 374.76562,457.31871 91.41332,21.08105 -59.30071,10.33177",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 497.0327,
        y1: 473.02473,
        x2: -41.27987,
        y2: -39.88423,
        x3: 9.63196,
        y3: 45.07605,
        d: "m 497.0327,473.02473 -41.27987,-39.88423 9.63196,45.07605",
        fill: "fff426",
        r: 255,
        g: 244,
        b: 38,
      },
      {
        x1: 580.77191,
        y1: 466.36097,
        x2: -83.73921,
        y2: 6.66376,
        x3: 64.08211,
        y3: 26.35937,
        d: "m 580.77191,466.36097 -83.73921,6.66376 64.08211,26.35937",
        fill: "4dc18d",
        r: 77,
        g: 193,
        b: 141,
      },
      {
        x1: 455.75283,
        y1: 433.1405,
        x2: 125.01908,
        y2: 33.22047,
        x3: -83.73921,
        y3: 6.66376,
        d: "m 455.75283,433.1405 125.01908,33.22047 -83.73921,6.66376",
        fill: "33b540",
        r: 51,
        g: 181,
        b: 64,
      },
      {
        x1: 455.75283,
        y1: 433.1405,
        x2: -80.98721,
        y2: 24.17821,
        x3: 91.41332,
        y3: 21.08105,
        d: "m 455.75283,433.1405 -80.98721,24.17821 91.41332,21.08105",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 578.21649,
        y1: 538.30591,
        x2: -1.47428,
        y2: 59.36441,
        x3: 47.66843,
        y3: -33.81018,
        d: "m 578.21649,538.30591 -1.47428,59.36441 47.66843,-33.81018",
        fill: "00aaaf",
        r: 0,
        g: 170,
        b: 175,
      },
      {
        x1: 603.77071,
        y1: 624.01082,
        x2: 20.63993,
        y2: -60.15068,
        x3: -47.66843,
        y3: 33.81018,
        d: "m 603.77071,624.01082 20.63993,-60.15068 -47.66843,33.81018",
        fill: "00a888",
        r: 0,
        g: 168,
        b: 136,
      },
      {
        x1: 603.77071,
        y1: 624.01082,
        x2: -24.76794,
        y2: 25.16107,
        x3: -4.52679,
        y3: -26.00667,
        d: "m 603.77071,624.01082 -24.76794,25.16107 -4.52679,-26.00667",
        fill: "66c430",
        r: 102,
        g: 196,
        b: 48,
      },
      {
        x1: 603.77071,
        y1: 624.01082,
        x2: -0.33907,
        y2: 21.67699,
        x3: -24.42887,
        y3: 3.48408,
        d: "m 603.77071,624.01082 -0.33907,21.67699 -24.42887,3.48408",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 603.43164,
        y1: 645.68781,
        x2: 11.54359,
        y2: 17.91876,
        x3: -35.97246,
        y3: -14.43468,
        d: "m 603.43164,645.68781 11.54359,17.91876 -35.97246,-14.43468",
        fill: "fff426",
        r: 255,
        g: 244,
        b: 38,
      },
      {
        x1: 579.00277,
        y1: 649.17189,
        x2: 5.30742,
        y2: 14.34968,
        x3: 30.66504,
        y3: 0.085,
        d: "m 579.00277,649.17189 5.30742,14.34968 30.66504,0.085",
        fill: "d9e70c",
        r: 217,
        g: 231,
        b: 12,
      },
      {
        x1: 603.43164,
        y1: 645.68781,
        x2: 18.81672,
        y2: 7.80865,
        x3: -7.27313,
        y3: 10.11011,
        d: "m 603.43164,645.68781 18.81672,7.80865 -7.27313,10.11011",
        fill: "cce310",
        r: 204,
        g: 227,
        b: 16,
      },
      {
        x1: 624.41064,
        y1: 563.86014,
        x2: 55.37706,
        y2: -46.38639,
        x3: -101.57121,
        y3: 20.83216,
        d: "m 624.41064,563.86014 55.37706,-46.38639 -101.57121,20.83216",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 609.47125,
        y1: 516.09341,
        x2: 70.31645,
        y2: 1.38034,
        x3: -101.57121,
        y3: 20.83216,
        d: "m 609.47125,516.09341 70.31645,1.38034 -101.57121,20.83216",
        fill: "079ae1",
        r: 7,
        g: 154,
        b: 225,
      },
      {
        x1: 679.7877,
        y1: 517.47375,
        x2: 35.83184,
        y2: -48.36079,
        x3: -79.43194,
        y3: 48.15515,
        d: "m 679.7877,517.47375 35.83184,-48.36079 -79.43194,48.15515",
        fill: "0d4f87",
        r: 13,
        g: 79,
        b: 135,
      },
      {
        x1: 636.1876,
        y1: 517.26811,
        x2: -55.41569,
        y2: -50.90714,
        x3: 28.69934,
        y3: 49.73244,
        d: "m 636.1876,517.26811 -55.41569,-50.90714 28.69934,49.73244",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 715.61954,
        y1: 469.11296,
        x2: 43.63873,
        y2: -17.69137,
        x3: -76.85921,
        y3: -3.53828,
        d: "m 715.61954,469.11296 43.63873,-17.69137 -76.85921,-3.53828",
        fill: "4b2a91",
        r: 75,
        g: 42,
        b: 145,
      },
      {
        x1: 636.1876,
        y1: 517.26811,
        x2: 79.43194,
        y2: -48.15515,
        x3: -33.22048,
        y3: -21.22965,
        d: "m 636.1876,517.26811 79.43194,-48.15515 -33.22048,-21.22965",
        fill: "153a75",
        r: 21,
        g: 58,
        b: 117,
      },
      {
        x1: 580.77191,
        y1: 466.36097,
        x2: 101.62715,
        y2: -18.47766,
        x3: -46.21146,
        y3: 69.3848,
        d: "m 580.77191,466.36097 101.62715,-18.47766 -46.21146,69.3848",
        fill: "1e5cb3",
        r: 30,
        g: 92,
        b: 179,
      },
      {
        x1: 759.25827,
        y1: 451.42159,
        x2: -51.69814,
        y2: -31.64792,
        x3: -25.16107,
        y3: 28.10964,
        d: "m 759.25827,451.42159 -51.69814,-31.64792 -25.16107,28.10964",
        fill: "7641a4",
        r: 118,
        g: 65,
        b: 164,
      },
      {
        x1: 455.75283,
        y1: 433.1405,
        x2: 98.87515,
        y2: -3.34171,
        x3: 26.14393,
        y3: 36.56218,
        d: "m 455.75283,433.1405 98.87515,-3.34171 26.14393,36.56218",
        fill: "b3db18",
        r: 179,
        g: 219,
        b: 24,
      },
      {
        x1: 554.62798,
        y1: 429.79879,
        x2: 26.14393,
        y2: 36.56218,
        x3: 101.62715,
        y3: -18.47766,
        d: "m 554.62798,429.79879 26.14393,36.56218 101.62715,-18.47766",
        fill: "0a92a2",
        r: 10,
        g: 146,
        b: 162,
      },
      {
        x1: 641.5123,
        y1: 416.43197,
        x2: 40.88676,
        y2: 31.45134,
        x3: 25.16107,
        y3: -28.10964,
        d: "m 641.5123,416.43197 40.88676,31.45134 25.16107,-28.10964",
        fill: "291639",
        r: 41,
        g: 22,
        b: 57,
      },
      {
        x1: 554.62798,
        y1: 429.79879,
        x2: 86.88432,
        y2: -13.36682,
        x3: 40.88676,
        y3: 31.45134,
        d: "m 554.62798,429.79879 86.88432,-13.36682 40.88676,31.45134",
        fill: "005e8a",
        r: 0,
        g: 94,
        b: 138,
      },
      {
        x1: 455.75283,
        y1: 433.1405,
        x2: 64.27867,
        y2: -48.55302,
        x3: 34.59648,
        y3: 45.21131,
        d: "m 455.75283,433.1405 64.27867,-48.55302 34.59648,45.21131",
        fill: "d9e70c",
        r: 217,
        g: 231,
        b: 12,
      },
      {
        x1: 641.5123,
        y1: 416.43197,
        x2: -121.4808,
        y2: -31.84449,
        x3: 34.59648,
        y3: 45.21131,
        d: "m 641.5123,416.43197 -121.4808,-31.84449 34.59648,45.21131",
        fill: "59c69e",
        r: 89,
        g: 198,
        b: 158,
      },
      {
        x1: 374.76562,
        y1: 457.31871,
        x2: 35.18619,
        y2: -46.78387,
        x3: 45.80102,
        y3: 22.60566,
        d: "m 374.76562,457.31871 35.18619,-46.78387 45.80102,22.60566",
        fill: "f9a70d",
        r: 249,
        g: 167,
        b: 13,
      },
      {
        x1: 520.0315,
        y1: 384.58748,
        x2: -110.07969,
        y2: 25.94736,
        x3: 45.80102,
        y3: 22.60566,
        d: "m 520.0315,384.58748 -110.07969,25.94736 45.80102,22.60566",
        fill: "fff426",
        r: 255,
        g: 244,
        b: 38,
      },
      {
        x1: 520.0315,
        y1: 384.58748,
        x2: 67.22725,
        y2: 8.64913,
        x3: 54.25355,
        y3: 23.19536,
        d: "m 520.0315,384.58748 67.22725,8.64913 54.25355,23.19536",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 641.5123,
        y1: 416.43197,
        x2: 57.79185,
        y2: -25.16108,
        x3: 8.25598,
        y3: 28.50278,
        d: "m 641.5123,416.43197 57.79185,-25.16108 8.25598,28.50278",
        fill: "143e65",
        r: 20,
        g: 62,
        b: 101,
      },
      {
        x1: 759.25827,
        y1: 451.42159,
        x2: 23.39193,
        y2: -5.50398,
        x3: -14.34967,
        y3: -9.23885,
        d: "m 759.25827,451.42159 23.39193,-5.50398 -14.34967,-9.23885",
        fill: "8d0e5c",
        r: 141,
        g: 14,
        b: 92,
      },
      {
        x1: 782.6502,
        y1: 445.91761,
        x2: 11.59769,
        y2: -16.11882,
        x3: -25.94736,
        y3: 6.87997,
        d: "m 782.6502,445.91761 11.59769,-16.11882 -25.94736,6.87997",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 794.24789,
        y1: 429.79879,
        x2: -32.23763,
        y2: -29.28906,
        x3: 6.29027,
        y3: 36.16903,
        d: "m 794.24789,429.79879 -32.23763,-29.28906 6.29027,36.16903",
        fill: "542791",
        r: 84,
        g: 39,
        b: 145,
      },
      {
        x1: 707.56013,
        y1: 419.77367,
        x2: 60.7404,
        y2: 16.90509,
        x3: -9.04226,
        y3: 14.74283,
        d: "m 707.56013,419.77367 60.7404,16.90509 -9.04226,14.74283",
        fill: "712090",
        r: 113,
        g: 32,
        b: 144,
      },
      {
        x1: 762.01026,
        y1: 400.50973,
        x2: -54.45013,
        y2: 19.26394,
        x3: 60.7404,
        y3: 16.90509,
        d: "m 762.01026,400.50973 -54.45013,19.26394 60.7404,16.90509",
        fill: "a945a9",
        r: 169,
        g: 69,
        b: 169,
      },
      {
        x1: 794.24789,
        y1: 429.79879,
        x2: -0.0845,
        y2: -14.1531,
        x3: -32.15319,
        y3: -15.13596,
        d: "m 794.24789,429.79879 -0.0845,-14.1531 -32.15319,-15.13596",
        fill: "a945a9",
        r: 169,
        g: 69,
        b: 169,
      },
      {
        x1: 789.79673,
        y1: 413.55574,
        x2: -17.56479,
        y2: -30.14768,
        x3: -10.22168,
        y3: 17.10167,
        d: "m 789.79673,413.55574 -17.56479,-30.14768 -10.22168,17.10167",
        fill: "7641a4",
        r: 118,
        g: 65,
        b: 164,
      },
      {
        x1: 699.30415,
        y1: 391.27089,
        x2: 36.95533,
        y2: -41.86959,
        x3: -28.69935,
        y3: 70.37237,
        d: "m 699.30415,391.27089 36.95533,-41.86959 -28.69935,70.37237",
        fill: "593c9f",
        r: 89,
        g: 60,
        b: 159,
      },
      {
        x1: 736.25948,
        y1: 349.4013,
        x2: 25.75078,
        y2: 51.10843,
        x3: -54.45013,
        y3: 19.26394,
        d: "m 736.25948,349.4013 25.75078,51.10843 -54.45013,19.26394",
        fill: "6a53ae",
        r: 106,
        g: 83,
        b: 174,
      },
      {
        x1: 772.23194,
        y1: 383.40806,
        x2: -25.80739,
        y2: -13.83072,
        x3: 15.58571,
        y3: 30.93239,
        d: "m 772.23194,383.40806 -25.80739,-13.83072 15.58571,30.93239",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 699.30415,
        y1: 391.27089,
        x2: 31.84447,
        y2: -52.87756,
        x3: 2.638,
        y3: 13.80951,
        d: "m 699.30415,391.27089 31.84447,-52.87756 2.638,13.80951",
        fill: "a945a9",
        r: 169,
        g: 69,
        b: 169,
      },
      {
        x1: 709.52854,
        y1: 476.70765,
        x2: -10.85894,
        y2: 39.98236,
        x3: -18.8819,
        y3: 0.78374,
        d: "m 709.52854,476.70765 -10.85894,39.98236 -18.8819,0.78374",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 701.07329,
        y1: 547.93789,
        x2: -66.9144,
        y2: 7.71057,
        x3: 45.62881,
        y3: -38.17471,
        d: "m 701.07329,547.93789 -66.9144,7.71057 45.62881,-38.17471",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 701.07329,
        y1: 547.93789,
        x2: 18.87081,
        y2: 27.7165,
        x3: -84.94694,
        y3: -20.1383,
        d: "m 701.07329,547.93789 18.87081,27.7165 -84.94694,-20.1383",
        fill: "291639",
        r: 41,
        g: 22,
        b: 57,
      },
      {
        x1: 640.27941,
        y1: 556.76785,
        x2: 51.75162,
        y2: 42.08189,
        x3: 27.91307,
        y3: -23.19535,
        d: "m 640.27941,556.76785 51.75162,42.08189 27.91307,-23.19535",
        fill: "312053",
        r: 49,
        g: 32,
        b: 83,
      },
      {
        x1: 719.9441,
        y1: 575.65439,
        x2: 41.47644,
        y2: 36.95532,
        x3: -69.38951,
        y3: -13.75997,
        d: "m 719.9441,575.65439 41.47644,36.95532 -69.38951,-13.75997",
        fill: "47165e",
        r: 71,
        g: 22,
        b: 94,
      },
      {
        x1: 729.01954,
        y1: 619.48813,
        x2: 29.05931,
        y2: 23.00036,
        x3: 3.34169,
        y3: -29.87878,
        d: "m 729.01954,619.48813 29.05931,23.00036 3.34169,-29.87878",
        fill: "8a2458",
        r: 138,
        g: 36,
        b: 88,
      },
      {
        x1: 761.42054,
        y1: 612.60971,
        x2: 24.96451,
        y2: 17.69137,
        x3: -28.3062,
        y3: 12.18741,
        d: "m 761.42054,612.60971 24.96451,17.69137 -28.3062,12.18741",
        fill: "8d0e5c",
        r: 141,
        g: 14,
        b: 92,
      },
      {
        x1: 786.38505,
        y1: 630.30108,
        x2: -2.55542,
        y2: 13.75997,
        x3: -25.75078,
        y3: -1.57256,
        d: "m 786.38505,630.30108 -2.55542,13.75997 -25.75078,-1.57256",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 498.01628,
        y1: 514.08481,
        x2: -17.29896,
        y2: 61.43827,
        x3: -15.33253,
        y3: -68.86508,
        d: "m 498.01628,514.08481 -17.29896,61.43827 -15.33253,-68.86508",
        fill: "880a1f",
        r: 136,
        g: 10,
        b: 31,
      },
      {
        x1: 415.94801,
        y1: 536.24585,
        x2: 4.52427,
        y2: 65.22458,
        x3: 44.91251,
        y3: -94.81243,
        d: "m 415.94801,536.24585 4.52427,65.22458 44.91251,-94.81243",
        fill: "cf181f",
        r: 207,
        g: 24,
        b: 31,
      },
      {
        x1: 480.71732,
        y1: 575.52308,
        x2: -60.24504,
        y2: 25.94735,
        x3: 44.91251,
        y3: -94.81243,
        d: "m 480.71732,575.52308 -60.24504,25.94735 44.91251,-94.81243",
        fill: "b01419",
        r: 176,
        g: 20,
        b: 25,
      },
      {
        x1: 480.71732,
        y1: 575.52308,
        x2: -18.60896,
        y2: 39.57679,
        x3: -41.63608,
        y3: -13.62944,
        d: "m 480.71732,575.52308 -18.60896,39.57679 -41.63608,-13.62944",
        fill: "e31b22",
        r: 227,
        g: 27,
        b: 34,
      },
      {
        x1: 462.10836,
        y1: 615.09987,
        x2: 24.37478,
        y2: 24.37479,
        x3: -66.01086,
        y3: -38.00423,
        d: "m 462.10836,615.09987 24.37478,24.37479 -66.01086,-38.00423",
        fill: "cf181f",
        r: 207,
        g: 24,
        b: 31,
      },
      {
        x1: 486.48314,
        y1: 639.47466,
        x2: 1.62682,
        y2: 19.91892,
        x3: 20.04015,
        y3: -2.74538,
        d: "m 486.48314,639.47466 1.62682,19.91892 20.04015,-2.74538",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 486.48314,
        y1: 639.47466,
        x2: 24.35278,
        y2: 3.14513,
        x3: -2.68581,
        y3: 14.02841,
        d: "m 486.48314,639.47466 24.35278,3.14513 -2.68581,14.02841",
        fill: "7d0d10",
        r: 125,
        g: 13,
        b: 16,
      },
      {
        x1: 420.47228,
        y1: 601.47043,
        x2: 40.32534,
        y2: 47.70146,
        x3: 1.10237,
        y3: -23.85034,
        d: "m 420.47228,601.47043 40.32534,47.70146 1.10237,-23.85034",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 488.10996,
        y1: 659.39358,
        x2: -26.20997,
        y2: -34.07203,
        x3: 24.58315,
        y3: 14.15311,
        d: "m 488.10996,659.39358 -26.20997,-34.07203 24.58315,14.15311",
        fill: "920f14",
        r: 146,
        g: 15,
        b: 20,
      },
      {
        x1: 488.10996,
        y1: 659.39358,
        x2: -26.20997,
        y2: -34.07203,
        x3: -1.10237,
        y3: 23.85034,
        d: "m 488.10996,659.39358 -26.20997,-34.07203 -1.10237,23.85034",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 409.95181,
        y1: 410.53484,
        x2: -44.46597,
        y2: -2.66926,
        x3: 9.27978,
        y3: 49.45313,
        d: "m 409.95181,410.53484 -44.46597,-2.66926 9.27978,49.45313",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 357.27082,
        y1: 368.20684,
        x2: -75.22139,
        y2: 21.75332,
        x3: 33.28574,
        y3: -34.59647,
        d: "m 357.27082,368.20684 -75.22139,21.75332 33.28574,-34.59647",
        fill: "cce310",
        r: 204,
        g: 227,
        b: 16,
      },
      {
        x1: 348.13761,
        y1: 412.56099,
        x2: -20.19438,
        y2: -35.87329,
        x3: 37.54261,
        y3: 31.17788,
        d: "m 348.13761,412.56099 -20.19438,-35.87329 37.54261,31.17788",
        fill: "d9e70c",
        r: 217,
        g: 231,
        b: 12,
      },
      {
        x1: 291.94009,
        y1: 387.10045,
        x2: 45.67363,
        y2: 6.23994,
        x3: -9.67049,
        y3: -16.65269,
        d: "m 291.94009,387.10045 45.67363,6.23994 -9.67049,-16.65269",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 315.33517,
        y1: 355.36369,
        x2: -54.05368,
        y2: 18.42135,
        x3: 20.76794,
        y3: 16.17512,
        d: "m 315.33517,355.36369 -54.05368,18.42135 20.76794,16.17512",
        fill: "66c430",
        r: 102,
        g: 196,
        b: 48,
      },
      {
        x1: 266.20431,
        y1: 421.73687,
        x2: -4.92282,
        y2: -47.95183,
        x3: -14.61482,
        y3: 43.43321,
        d: "m 266.20431,421.73687 -4.92282,-47.95183 -14.61482,43.43321",
        fill: "0f868e",
        r: 15,
        g: 134,
        b: 142,
      },
      {
        x1: 282.04943,
        y1: 389.96016,
        x2: -16.57872,
        y2: 26.05586,
        x3: -4.18922,
        y3: -42.23098,
        d: "m 282.04943,389.96016 -16.57872,26.05586 -4.18922,-42.23098",
        fill: "00a878",
        r: 0,
        g: 168,
        b: 120,
      },
      {
        x1: 272.4364,
        y1: 446.9485,
        x2: -10.86683,
        y2: 17.21066,
        x3: -14.9029,
        y3: -46.94091,
        d: "m 272.4364,446.9485 -10.86683,17.21066 -14.9029,-46.94091",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 357.27082,
        y1: 368.20684,
        x2: -29.32759,
        y2: 8.48086,
        x3: 37.54261,
        y3: 31.17788,
        d: "m 357.27082,368.20684 -29.32759,8.48086 37.54261,31.17788",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 409.95181,
        y1: 410.53484,
        x2: -44.46597,
        y2: -2.66926,
        x3: -8.21502,
        y3: -39.65874,
        d: "m 409.95181,410.53484 -44.46597,-2.66926 -8.21502,-39.65874",
        fill: "f9a70d",
        r: 249,
        g: 167,
        b: 13,
      },
      {
        x1: 437.34528,
        y1: 523.48321,
        x2: -24.83804,
        y2: 14.8227,
        x3: -44.51781,
        y3: -61.49051,
        d: "m 437.34528,523.48321 -24.83804,14.8227 -44.51781,-61.49051",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 409.95181,
        y1: 410.53484,
        x2: 48.63378,
        y2: -21.01896,
        x3: 61.44591,
        y3: -4.9284,
        d: "m 409.95181,410.53484 48.63378,-21.01896 61.44591,-4.9284",
        fill: "d9e70c",
        r: 217,
        g: 231,
        b: 12,
      },
      {
        x1: 348.13761,
        y1: 412.56099,
        x2: 26.62801,
        y2: 44.75772,
        x3: -9.27978,
        y3: -49.45313,
        d: "m 348.13761,412.56099 26.62801,44.75772 -9.27978,-49.45313",
        fill: "fff426",
        r: 255,
        g: 244,
        b: 38,
      },
      {
        x1: 576.74221,
        y1: 597.67032,
        x2: -2.26623,
        y2: 25.4949,
        x3: 29.29473,
        y3: 0.8456,
        d: "m 576.74221,597.67032 -2.26623,25.4949 29.29473,0.8456",
        fill: "33b540",
        r: 51,
        g: 181,
        b: 64,
      },
      {
        x1: 729.01954,
        y1: 619.48813,
        x2: -23.63016,
        y2: -18.35806,
        x3: 56.03116,
        y3: 11.47964,
        d: "m 729.01954,619.48813 -23.63016,-18.35806 56.03116,11.47964",
        fill: "8d0e5c",
        r: 141,
        g: 14,
        b: 92,
      },
      {
        x1: 609.47125,
        y1: 516.09341,
        x2: -65.4581,
        y2: 9.65005,
        x3: 17.10166,
        y3: -26.35936,
        d: "m 609.47125,516.09341 -65.4581,9.65005 17.10166,-26.35936",
        fill: "0d4f87",
        r: 13,
        g: 79,
        b: 135,
      },
      {
        x1: 701.07329,
        y1: 547.93789,
        x2: -2.40369,
        y2: -31.24788,
        x3: -18.8819,
        y3: 0.78374,
        d: "m 701.07329,547.93789 -2.40369,-31.24788 -18.8819,0.78374",
        fill: "291639",
        r: 41,
        g: 22,
        b: 57,
      },
      {
        x1: 498.01628,
        y1: 514.08481,
        x2: -17.29896,
        y2: 61.43827,
        x3: 38.34972,
        y3: -56.04545,
        d: "m 498.01628,514.08481 -17.29896,61.43827 38.34972,-56.04545",
        fill: "a40f44",
        r: 164,
        g: 15,
        b: 68,
      },
      {
        x1: 272.4364,
        y1: 446.9485,
        x2: -6.23209,
        y2: -25.21163,
        x3: -19.53764,
        y3: -4.51862,
        d: "m 272.4364,446.9485 -6.23209,-25.21163 -19.53764,-4.51862",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
    ];

    const bear = [
      {
        x1: 408.61349,
        y1: 690.59851,
        x2: 86.94654,
        y2: 2.06239,
        x3: -44.81743,
        y3: -31.78819,
        d: "m 408.61349,690.59851 86.94654,2.06239 -44.81743,-31.78819",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 495.56003,
        y1: 692.6609,
        x2: 45.13117,
        y2: -71.16469,
        x3: -89.9486,
        y3: 39.3765,
        d: "m 495.56003,692.6609 45.13117,-71.16469 -89.9486,39.3765",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 450.7426,
        y1: 660.87271,
        x2: 29.7258,
        y2: -82.6131,
        x3: 60.2228,
        y3: 43.2366,
        d: "m 450.7426,660.87271 29.7258,-82.6131 60.2228,43.2366",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 408.61349,
        y1: 690.59851,
        x2: -1.08633,
        y2: -18.82374,
        x3: 43.21544,
        y3: -10.90206,
        d: "m 408.61349,690.59851 -1.08633,-18.82374 43.21544,-10.90206",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 540.6912,
        y1: 621.49621,
        x2: 17.7577,
        y2: -76.0511,
        x3: -77.9805,
        y3: 32.8145,
        d: "m 540.6912,621.49621 17.7577,-76.0511 -77.9805,32.8145",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 459.2363,
        y1: 637.26881,
        x2: -22.3913,
        y2: -119.6189,
        x3: 43.6234,
        y3: 60.6097,
        d: "m 459.2363,637.26881 -22.3913,-119.6189 43.6234,60.6097",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 558.4489,
        y1: 545.44511,
        x2: -17.7577,
        y2: -95.7382,
        x3: -60.2228,
        y3: 128.5527,
        d: "m 558.4489,545.44511 -17.7577,-95.7382 -60.2228,128.5527",
        fill: "ed1c24",
        r: 237,
        g: 28,
        b: 36,
      },
      {
        x1: 480.4684,
        y1: 578.25961,
        x2: -43.6234,
        y2: -60.6097,
        x3: 103.8462,
        y3: -67.943,
        d: "m 480.4684,578.25961 -43.6234,-60.6097 103.8462,-67.943",
        fill: "d91920",
        r: 217,
        g: 25,
        b: 32,
      },
      {
        x1: 540.6912,
        y1: 449.70691,
        x2: 67.95454,
        y2: 70.67521,
        x3: -50.19684,
        y3: 25.06299,
        d: "m 540.6912,449.70691 67.95454,70.67521 -50.19684,25.06299",
        fill: "ba0459",
        r: 186,
        g: 4,
        b: 89,
      },
      {
        x1: 723.4028,
        y1: 473.95241,
        x2: -52.56816,
        y2: -58.09268,
        x3: -130.14344,
        y3: 33.84718,
        d: "m 723.4028,473.95241 -52.56816,-58.09268 -130.14344,33.84718",
        fill: "4dc18d",
        r: 77,
        g: 193,
        b: 141,
      },
      {
        x1: 765.3689,
        y1: 396.23941,
        x2: 6.9488,
        y2: 144.1875,
        x3: -48.9149,
        y3: -66.4745,
        d: "m 765.3689,396.23941 6.9488,144.1875 -48.9149,-66.4745",
        fill: "0772ad",
        r: 7,
        g: 114,
        b: 173,
      },
      {
        x1: 765.3689,
        y1: 396.23941,
        x2: 15.0557,
        y2: 72.0938,
        x3: -8.1069,
        y3: 72.0937,
        d: "m 765.3689,396.23941 15.0557,72.0938 -8.1069,72.0937",
        fill: "2350a9",
        r: 35,
        g: 80,
        b: 169,
      },
      {
        x1: 772.3177,
        y1: 540.42691,
        x2: -104.811,
        y2: 37.0325,
        x3: 55.8961,
        y3: -103.507,
        d: "m 772.3177,540.42691 -104.811,37.0325 55.8961,-103.507",
        fill: "05768d",
        r: 5,
        g: 118,
        b: 141,
      },
      {
        x1: 789.26252,
        y1: 588.58587,
        x2: -50.97422,
        y2: 12.79704,
        x3: -70.7816,
        y3: -23.9235,
        d: "m 789.26252,588.58587 -50.97422,12.79704 -70.7816,-23.9235",
        fill: "1082ce",
        r: 16,
        g: 130,
        b: 206,
      },
      {
        x1: 797.7966,
        y1: 621.49621,
        x2: -74.3938,
        y2: 65.3071,
        x3: 14.8855,
        y3: -85.4204,
        d: "m 797.7966,621.49621 -74.3938,65.3071 14.8855,-85.4204",
        fill: "2350a9",
        r: 35,
        g: 80,
        b: 169,
      },
      {
        x1: 667.5067,
        y1: 577.45941,
        x2: 63.79,
        y2: 64.0435,
        x3: 6.9916,
        y3: -40.12,
        d: "m 667.5067,577.45941 63.79,64.0435 6.9916,-40.12",
        fill: "104680",
        r: 16,
        g: 70,
        b: 128,
      },
      {
        x1: 797.7966,
        y1: 621.49621,
        x2: -17.372,
        y2: 44.5881,
        x3: -57.0218,
        y3: 20.719,
        d: "m 797.7966,621.49621 -17.372,44.5881 -57.0218,20.719",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 728.7627,
        y1: 656.04671,
        x2: -36.3561,
        y2: 19.6883,
        x3: 30.9962,
        y3: 11.0683,
        d: "m 728.7627,656.04671 -36.3561,19.6883 30.9962,11.0683",
        fill: "1082ce",
        r: 16,
        g: 130,
        b: 206,
      },
      {
        x1: 652.34554,
        y1: 632.75304,
        x2: -16.68744,
        y2: 28.11967,
        x3: -40.75249,
        y3: -60.78598,
        d: "m 652.34554,632.75304 -16.68744,28.11967 -40.75249,-60.78598",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 594.90561,
        y1: 600.08673,
        x2: -22.94481,
        y2: 41.41618,
        x3: 63.6973,
        y3: 19.3698,
        d: "m 594.90561,600.08673 -22.94481,41.41618 63.6973,19.3698",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 635.6581,
        y1: 660.87271,
        x2: -46.1137,
        y2: 11.1779,
        x3: -17.5836,
        y3: -30.5477,
        d: "m 635.6581,660.87271 -46.1137,11.1779 -17.5836,-30.5477",
        fill: "80cc28",
        r: 128,
        g: 204,
        b: 40,
      },
      {
        x1: 571.9608,
        y1: 641.50291,
        x2: -31.2696,
        y2: 10.1047,
        x3: 48.8532,
        y3: 20.443,
        d: "m 571.9608,641.50291 -31.2696,10.1047 48.8532,20.443",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 589.5444,
        y1: 672.05061,
        x2: -61.0135,
        y2: -0.625,
        x3: 12.1603,
        y3: -19.818,
        d: "m 589.5444,672.05061 -61.0135,-0.625 12.1603,-19.818",
        fill: "33b540",
        r: 51,
        g: 181,
        b: 64,
      },
      {
        x1: 436.845,
        y1: 517.64991,
        x2: -94.7735,
        y2: -40.3412,
        x3: 102.4415,
        y3: 81.3078,
        d: "m 436.845,517.64991 -94.7735,-40.3412 102.4415,81.3078",
        fill: "870e12",
        r: 135,
        g: 14,
        b: 18,
      },
      {
        x1: 638.99078,
        y1: 400.42509,
        x2: 97.11562,
        y2: -49.18843,
        x3: -65.27176,
        y3: 64.62307,
        d: "m 638.99078,400.42509 97.11562,-49.18843 -65.27176,64.62307",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 596.08867,
        y1: 345.88566,
        x2: -51.34397,
        y2: -43.45495,
        x3: -39.9556,
        y3: 60.2229,
        d: "m 596.08867,345.88566 -51.34397,-43.45495 -39.9556,60.2229",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: -112.83785,
        y2: -23.36059,
        x3: 91.29957,
        y3: -16.76795,
        d: "m 617.62695,386.0142 -112.83785,-23.36059 91.29957,-16.76795",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 473.57496,
        y1: 438.45939,
        x2: -18.44195,
        y2: 39.4614,
        x3: 85.55819,
        y3: -28.21388,
        d: "m 473.57496,438.45939 -18.44195,39.4614 85.55819,-28.21388",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 692.4066,
        y1: 322.69801,
        x2: -59.15773,
        y2: -20.7069,
        x3: -88.50417,
        y3: 0.4396,
        d: "m 692.4066,322.69801 -59.15773,-20.7069 -88.50417,0.4396",
        fill: "ed0f53",
        r: 237,
        g: 15,
        b: 83,
      },
      {
        x1: 473.57496,
        y1: 438.45939,
        x2: -131.50346,
        y2: 38.84932,
        x3: 113.06151,
        y3: 0.61208,
        d: "m 473.57496,438.45939 -131.50346,38.84932 113.06151,0.61208",
        fill: "ed114e",
        r: 237,
        g: 17,
        b: 78,
      },
      {
        x1: 496.58574,
        y1: 303.32254,
        x2: -44.01507,
        y2: -2.8987,
        x3: 52.21843,
        y3: 62.22977,
        d: "m 496.58574,303.32254 -44.01507,-2.8987 52.21843,62.22977",
        fill: "7d0f6b",
        r: 125,
        g: 15,
        b: 107,
      },
      {
        x1: 403.9943,
        y1: 371.55405,
        x2: -61.9228,
        y2: 105.75466,
        x3: 113.63372,
        y3: -107.0159,
        d: "m 403.9943,371.55405 -61.9228,105.75466 113.63372,-107.0159",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 333.9646,
        y1: 367.86521,
        x2: 21.7532,
        y2: 61.3092,
        x3: 25.1014,
        y3: -88.5392,
        d: "m 333.9646,367.86521 21.7532,61.3092 25.1014,-88.5392",
        fill: "97168f",
        r: 151,
        g: 22,
        b: 143,
      },
      {
        x1: 333.9646,
        y1: 367.86521,
        x2: -23.7417,
        y2: -22.0045,
        x3: 36.4812,
        y3: -16.2139,
        d: "m 333.9646,367.86521 -23.7417,-22.0045 36.4812,-16.2139",
        fill: "f140a9",
        r: 241,
        g: 64,
        b: 169,
      },
      {
        x1: 346.7041,
        y1: 329.64681,
        x2: 13.9647,
        y2: 22.6994,
        x3: -26.7042,
        y3: 15.519,
        d: "m 346.7041,329.64681 13.9647,22.6994 -26.7042,15.519",
        fill: "ec0677",
        r: 236,
        g: 6,
        b: 119,
      },
      {
        x1: 346.7041,
        y1: 329.64681,
        x2: 34.1151,
        y2: 10.9884,
        x3: -20.1504,
        y3: 11.711,
        d: "m 346.7041,329.64681 34.1151,10.9884 -20.1504,11.711",
        fill: "c60d7e",
        r: 198,
        g: 13,
        b: 126,
      },
      {
        x1: 393.2923,
        y1: 296.64011,
        x2: -46.5882,
        y2: 33.0067,
        x3: 34.1151,
        y3: 10.9884,
        d: "m 393.2923,296.64011 -46.5882,33.0067 34.1151,10.9884",
        fill: "70174e",
        r: 112,
        g: 23,
        b: 78,
      },
      {
        x1: 272.58361,
        y1: 340.63521,
        x2: 45.16719,
        y2: -17.9372,
        x3: -7.5279,
        y3: 23.1627,
        d: "m 272.58361,340.63521 45.16719,-17.9372 -7.5279,23.1627",
        fill: "7e1355",
        r: 126,
        g: 19,
        b: 85,
      },
      {
        x1: 346.7041,
        y1: 329.64681,
        x2: -28.9533,
        y2: -6.9488,
        x3: -7.5279,
        y3: 23.1627,
        d: "m 346.7041,329.64681 -28.9533,-6.9488 -7.5279,23.1627",
        fill: "331249",
        r: 51,
        g: 18,
        b: 73,
      },
      {
        x1: 317.7508,
        y1: 322.69801,
        x2: 75.5415,
        y2: -26.0579,
        x3: -46.5882,
        y3: 33.0067,
        d: "m 317.7508,322.69801 75.5415,-26.0579 -46.5882,33.0067",
        fill: "891551",
        r: 137,
        g: 21,
        b: 81,
      },
      {
        x1: 272.58361,
        y1: 340.63521,
        x2: -22.00452,
        y2: -21.9976,
        x3: 42.38301,
        y3: 13.9046,
        d: "m 272.58361,340.63521 -22.00452,-21.9976 42.38301,13.9046",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 250.57909,
        y1: 318.63761,
        x2: 0.41667,
        y2: 26.54602,
        x3: 21.58785,
        y3: -4.54842,
        d: "m 250.57909,318.63761 0.41667,26.54602 21.58785,-4.54842",
        fill: "ec0677",
        r: 236,
        g: 6,
        b: 119,
      },
      {
        x1: 333.78918,
        y1: 537.38443,
        x2: -104.05647,
        y2: 21.23208,
        x3: 112.33879,
        y3: -81.3078,
        d: "m 333.78918,537.38443 -104.05647,21.23208 112.33879,-81.3078",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 333.78918,
        y1: 537.38443,
        x2: -14.30118,
        y2: 53.42128,
        x3: -89.75529,
        y3: -32.1892,
        d: "m 333.78918,537.38443 -14.30118,53.42128 -89.75529,-32.1892",
        fill: "9c0a5f",
        r: 156,
        g: 10,
        b: 95,
      },
      {
        x1: 267.65807,
        y1: 604.14391,
        x2: -59.92987,
        y2: 15.4217,
        x3: 22.00451,
        y3: -60.9491,
        d: "m 267.65807,604.14391 -59.92987,15.4217 22.00451,-60.9491",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 267.65807,
        y1: 604.14391,
        x2: -57.03454,
        y2: 54.7982,
        x3: -2.89533,
        y3: -39.3765,
        d: "m 267.65807,604.14391 -57.03454,54.7982 -2.89533,-39.3765",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 256.90365,
        y1: 614.47671,
        x2: -16.16868,
        y2: 52.7657,
        x3: -30.11144,
        y3: -8.3003,
        d: "m 256.90365,614.47671 -16.16868,52.7657 -30.11144,-8.3003",
        fill: "1e2060",
        r: 30,
        g: 32,
        b: 96,
      },
      {
        x1: 229.73271,
        y1: 558.61651,
        x2: 54.28212,
        y2: -79.95363,
        x3: 58.05667,
        y3: -1.35417,
        d: "m 229.73271,558.61651 54.28212,-79.95363 58.05667,-1.35417",
        fill: "99224b",
        r: 153,
        g: 34,
        b: 75,
      },
      {
        x1: 284.01483,
        y1: 478.66288,
        x2: 71.70297,
        y2: -49.48847,
        x3: -13.6463,
        y3: 48.1343,
        d: "m 284.01483,478.66288 71.70297,-49.48847 -13.6463,48.1343",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 333.9646,
        y1: 367.86521,
        x2: -49.94977,
        y2: 110.79767,
        x3: 71.70297,
        y3: -49.48847,
        d: "m 333.9646,367.86521 -49.94977,110.79767 71.70297,-49.48847",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 310.2229,
        y1: 345.86071,
        x2: -64.27634,
        y2: 57.3275,
        x3: 26.63705,
        y3: -62.553,
        d: "m 310.2229,345.86071 -64.27634,57.3275 26.63705,-62.553",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 250.99576,
        y1: 345.18363,
        x2: -5.0492,
        y2: 58.00458,
        x3: 26.63705,
        y3: -62.553,
        d: "m 250.99576,345.18363 -5.0492,58.00458 26.63705,-62.553",
        fill: "be1b4c",
        r: 190,
        g: 27,
        b: 76,
      },
      {
        x1: 333.9646,
        y1: 367.86521,
        x2: -88.01804,
        y2: 35.323,
        x3: 64.27634,
        y3: -57.3275,
        d: "m 333.9646,367.86521 -88.01804,35.323 64.27634,-57.3275",
        fill: "880046",
        r: 136,
        g: 0,
        b: 70,
      },
      {
        x1: 284.01483,
        y1: 478.66288,
        x2: -60.07278,
        y2: -8.30297,
        x3: 86.28085,
        y3: -49.7047,
        d: "m 284.01483,478.66288 -60.07278,-8.30297 86.28085,-49.7047",
        fill: "281549",
        r: 40,
        g: 21,
        b: 73,
      },
      {
        x1: 245.94656,
        y1: 403.18821,
        x2: 64.27634,
        y2: 17.467,
        x3: 23.7417,
        y3: -52.79,
        d: "m 245.94656,403.18821 64.27634,17.467 23.7417,-52.79",
        fill: "6e126b",
        r: 110,
        g: 18,
        b: 107,
      },
      {
        x1: 245.94656,
        y1: 403.18821,
        x2: -43.42996,
        y2: 40.5347,
        x3: 107.7063,
        y3: -23.0677,
        d: "m 245.94656,403.18821 -43.42996,40.5347 107.7063,-23.0677",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 310.2229,
        y1: 420.65521,
        x2: -107.7063,
        y2: 23.0677,
        x3: 21.42545,
        y3: 26.637,
        d: "m 310.2229,420.65521 -107.7063,23.0677 21.42545,26.637",
        fill: "5e2590",
        r: 94,
        g: 37,
        b: 144,
      },
      {
        x1: 225.16272,
        y1: 422.58691,
        x2: 25.83304,
        y2: -77.40328,
        x3: -5.0492,
        y3: 58.00458,
        d: "m 225.16272,422.58691 25.83304,-77.40328 -5.0492,58.00458",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 250.99576,
        y1: 345.18363,
        x2: -25.73276,
        y2: 39.72118,
        x3: -0.10028,
        y3: 37.6821,
        d: "m 250.99576,345.18363 -25.73276,39.72118 -0.10028,37.6821",
        fill: "ec0677",
        r: 236,
        g: 6,
        b: 119,
      },
      {
        x1: 723.4028,
        y1: 473.95241,
        x2: -114.75706,
        y2: 46.42971,
        x3: -67.95454,
        y3: -70.67521,
        d: "m 723.4028,473.95241 -114.75706,46.42971 -67.95454,-70.67521",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 723.4028,
        y1: 473.95241,
        x2: -114.75706,
        y2: 46.42971,
        x3: 58.86096,
        y3: 57.07729,
        d: "m 723.4028,473.95241 -114.75706,46.42971 58.86096,57.07729",
        fill: "009100",
        r: 0,
        g: 145,
        b: 0,
      },
      {
        x1: 784.80336,
        y1: 567.18189,
        x2: -12.48566,
        y2: -26.75498,
        x3: -43.72047,
        y3: 31.68151,
        d: "m 784.80336,567.18189 -12.48566,-26.75498 -43.72047,31.68151",
        fill: "0772ad",
        r: 7,
        g: 114,
        b: 173,
      },
      {
        x1: 789.26252,
        y1: 588.58587,
        x2: -4.45916,
        y2: -21.40398,
        x3: -117.29666,
        y3: 10.27752,
        d: "m 789.26252,588.58587 -4.45916,-21.40398 -117.29666,10.27752",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 663.04753,
        y1: 613.13272,
        x2: 4.45917,
        y2: -35.67331,
        x3: -109.0578,
        y3: -32.0143,
        d: "m 663.04753,613.13272 4.45917,-35.67331 -109.0578,-32.0143",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: 118.47945,
        y2: -34.77754,
        x3: -43.6998,
        y3: -28.53865,
        d: "m 617.62695,386.0142 118.47945,-34.77754 -43.6998,-28.53865",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 455.70522,
        y1: 370.29281,
        x2: -62.41292,
        y2: -73.6527,
        x3: 111.4968,
        y3: 66.0135,
        d: "m 455.70522,370.29281 -62.41292,-73.6527 111.4968,66.0135",
        fill: "ba0459",
        r: 186,
        g: 4,
        b: 89,
      },
      {
        x1: 608.64574,
        y1: 520.38212,
        x2: -50.19684,
        y2: 25.06299,
        x3: 109.0578,
        y3: 32.0143,
        d: "m 608.64574,520.38212 -50.19684,25.06299 109.0578,32.0143",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: -112.83785,
        y2: -23.36059,
        x3: 35.9021,
        y3: 87.0533,
        d: "m 617.62695,386.0142 -112.83785,-23.36059 35.9021,87.0533",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: 21.36383,
        y2: 14.41089,
        x3: -98.29958,
        y3: 49.28182,
        d: "m 617.62695,386.0142 21.36383,14.41089 -98.29958,49.28182",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 723.4028,
        y1: 473.95241,
        x2: -52.56816,
        y2: -58.09268,
        x3: 94.53426,
        y3: -19.62032,
        d: "m 723.4028,473.95241 -52.56816,-58.09268 94.53426,-19.62032",
        fill: "26b9f1",
        r: 38,
        g: 185,
        b: 241,
      },
      {
        x1: 753.3871,
        y1: 377.32078,
        x2: -17.2807,
        y2: -26.08412,
        x3: -65.27176,
        y3: 64.62307,
        d: "m 753.3871,377.32078 -17.2807,-26.08412 -65.27176,64.62307",
        fill: "0772ad",
        r: 7,
        g: 114,
        b: 173,
      },
      {
        x1: 765.3689,
        y1: 396.23941,
        x2: -29.2625,
        y2: -45.00275,
        x3: 25.69517,
        y3: 18.24777,
        d: "m 765.3689,396.23941 -29.2625,-45.00275 25.69517,18.24777",
        fill: "104680",
        r: 16,
        g: 70,
        b: 128,
      },
      {
        x1: 596.08867,
        y1: 345.88566,
        x2: -51.34397,
        y2: -43.45495,
        x3: 147.6619,
        y3: 20.2673,
        d: "m 596.08867,345.88566 -51.34397,-43.45495 147.6619,20.2673",
        fill: "f57c14",
        r: 245,
        g: 124,
        b: 20,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: 74.77965,
        y2: -63.31619,
        x3: -96.31793,
        y3: 23.18765,
        d: "m 617.62695,386.0142 74.77965,-63.31619 -96.31793,23.18765",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 663.04753,
        y1: 613.13272,
        x2: -10.70199,
        y2: 19.62032,
        x3: -93.89664,
        y3: -87.30793,
        d: "m 663.04753,613.13272 -10.70199,19.62032 -93.89664,-87.30793",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 719.29587,
        y1: 332.50424,
        x2: 16.81053,
        y2: 18.73242,
        x3: -43.6998,
        y3: -28.53865,
        d: "m 719.29587,332.50424 16.81053,18.73242 -43.6998,-28.53865",
        fill: "0772ad",
        r: 7,
        g: 114,
        b: 173,
      },
      {
        x1: 403.9943,
        y1: 371.55405,
        x2: -10.702,
        y2: -74.91394,
        x3: -21.40398,
        y3: 74.91394,
        d: "m 403.9943,371.55405 -10.702,-74.91394 -21.40398,74.91394",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 403.9943,
        y1: 371.55405,
        x2: -61.9228,
        y2: 105.75466,
        x3: 29.81682,
        y3: -105.75466,
        d: "m 403.9943,371.55405 -61.9228,105.75466 29.81682,-105.75466",
        fill: "99224b",
        r: 153,
        g: 34,
        b: 75,
      },
      {
        x1: 333.78918,
        y1: 537.38443,
        x2: 70.74273,
        y2: -12.65756,
        x3: -62.46041,
        y3: -47.41816,
        d: "m 333.78918,537.38443 70.74273,-12.65756 -62.46041,-47.41816",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 333.78918,
        y1: 537.38443,
        x2: -14.30118,
        y2: 53.42128,
        x3: 85.04391,
        y3: -66.07884,
        d: "m 333.78918,537.38443 -14.30118,53.42128 85.04391,-66.07884",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 454.33304,
        y1: 650.91851,
        x2: -35.41917,
        y2: 11.80733,
        x3: 31.82873,
        y3: -1.85313,
        d: "m 454.33304,650.91851 -35.41917,11.80733 31.82873,-1.85313",
        fill: "80cc28",
        r: 128,
        g: 204,
        b: 40,
      },
      {
        x1: 473.57496,
        y1: 438.45939,
        x2: -131.50346,
        y2: 38.84932,
        x3: 162.7176,
        y3: -114.6551,
        d: "m 473.57496,438.45939 -131.50346,38.84932 162.7176,-114.6551",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 473.57496,
        y1: 438.45939,
        x2: 31.21414,
        y2: -75.80578,
        x3: 35.9021,
        y3: 87.0533,
        d: "m 473.57496,438.45939 31.21414,-75.80578 35.9021,87.0533",
        fill: "f57c14",
        r: 245,
        g: 124,
        b: 20,
      },
      {
        x1: 267.65807,
        y1: 604.14391,
        x2: 51.82993,
        y2: -13.3382,
        x3: -89.75529,
        y3: -32.1892,
        d: "m 267.65807,604.14391 51.82993,-13.3382 -89.75529,-32.1892",
        fill: "870e12",
        r: 135,
        g: 14,
        b: 18,
      },
      {
        x1: 455.70522,
        y1: 370.29281,
        x2: -62.41292,
        y2: -73.6527,
        x3: 10.702,
        y3: 74.91394,
        d: "m 455.70522,370.29281 -62.41292,-73.6527 10.702,74.91394",
        fill: "7d0f6b",
        r: 125,
        g: 15,
        b: 107,
      },
      {
        x1: 504.7891,
        y1: 362.65361,
        x2: -162.7176,
        y2: 114.6551,
        x3: 113.63372,
        y3: -107.0159,
        d: "m 504.7891,362.65361 -162.7176,114.6551 113.63372,-107.0159",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 393.2923,
        y1: 296.64011,
        x2: 59.27837,
        y2: 3.78373,
        x3: 52.21843,
        y3: 62.22977,
        d: "m 393.2923,296.64011 59.27837,3.78373 52.21843,62.22977",
        fill: "891551",
        r: 137,
        g: 21,
        b: 81,
      },
      {
        x1: 365.32023,
        y1: 573.96044,
        x2: -45.83223,
        y2: 16.84527,
        x3: 85.04391,
        y3: -66.07884,
        d: "m 365.32023,573.96044 -45.83223,16.84527 85.04391,-66.07884",
        fill: "1e2060",
        r: 30,
        g: 32,
        b: 96,
      },
      {
        x1: 617.62695,
        y1: 386.0142,
        x2: 21.36383,
        y2: 14.41089,
        x3: 97.11562,
        y3: -49.18843,
        d: "m 617.62695,386.0142 21.36383,14.41089 97.11562,-49.18843",
        fill: "80cc28",
        r: 128,
        g: 204,
        b: 40,
      },
      {
        x1: 638.99078,
        y1: 400.42509,
        x2: -98.29958,
        y2: 49.28182,
        x3: 130.14344,
        y3: -33.84718,
        d: "m 638.99078,400.42509 -98.29958,49.28182 130.14344,-33.84718",
        fill: "33b540",
        r: 51,
        g: 181,
        b: 64,
      },
      {
        x1: 728.7627,
        y1: 656.04671,
        x2: -36.3561,
        y2: 19.6883,
        x3: 38.13086,
        y3: -27.72642,
        d: "m 728.7627,656.04671 -36.3561,19.6883 38.13086,-27.72642",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 418.91387,
        y1: 662.72584,
        x2: -11.38671,
        y2: 9.04893,
        x3: 43.21544,
        y3: -10.90206,
        d: "m 418.91387,662.72584 -11.38671,9.04893 43.21544,-10.90206",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 436.845,
        y1: 517.64991,
        x2: -94.7735,
        y2: -40.3412,
        x3: 113.06151,
        y3: 0.61208,
        d: "m 436.845,517.64991 -94.7735,-40.3412 113.06151,0.61208",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 436.845,
        y1: 517.64991,
        x2: 18.28801,
        y2: -39.72912,
        x3: 85.55819,
        y3: -28.21388,
        d: "m 436.845,517.64991 18.28801,-39.72912 85.55819,-28.21388",
        fill: "be1b4c",
        r: 190,
        g: 27,
        b: 76,
      },
      {
        x1: 789.26252,
        y1: 588.58587,
        x2: -50.97422,
        y2: 12.79704,
        x3: 59.5083,
        y3: 20.1133,
        d: "m 789.26252,588.58587 -50.97422,12.79704 59.5083,20.1133",
        fill: "104680",
        r: 16,
        g: 70,
        b: 128,
      },
      {
        x1: 496.58574,
        y1: 303.32254,
        x2: 48.15896,
        y2: -0.89183,
        x3: -39.9556,
        y3: 60.2229,
        d: "m 496.58574,303.32254 48.15896,-0.89183 -39.9556,60.2229",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 797.7966,
        y1: 621.49621,
        x2: -17.372,
        y2: 44.5881,
        x3: 12.54115,
        y3: -14.95431,
        d: "m 797.7966,621.49621 -17.372,44.5881 12.54115,-14.95431",
        fill: "104680",
        r: 16,
        g: 70,
        b: 128,
      },
      {
        x1: 667.5067,
        y1: 577.45941,
        x2: 104.811,
        y2: -37.0325,
        x3: -43.72047,
        y3: 31.68151,
        d: "m 667.5067,577.45941 104.811,-37.0325 -43.72047,31.68151",
        fill: "2350a9",
        r: 35,
        g: 80,
        b: 169,
      },
      {
        x1: 594.90561,
        y1: 600.08673,
        x2: -22.94481,
        y2: 41.41618,
        x3: -2.74423,
        y3: -80.06954,
        d: "m 594.90561,600.08673 -22.94481,41.41618 -2.74423,-80.06954",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 652.34554,
        y1: 632.75304,
        x2: -93.89664,
        y2: -87.30793,
        x3: 36.45671,
        y3: 54.64162,
        d: "m 652.34554,632.75304 -93.89664,-87.30793 36.45671,54.64162",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 753.3871,
        y1: 377.32078,
        x2: 11.9818,
        y2: 18.91863,
        x3: -94.53426,
        y3: 19.62032,
        d: "m 753.3871,377.32078 11.9818,18.91863 -94.53426,19.62032",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 256.90365,
        y1: 614.47671,
        x2: -16.16868,
        y2: 52.7657,
        x3: 12.77078,
        y3: -27.53424,
        d: "m 256.90365,614.47671 -16.16868,52.7657 12.77078,-27.53424",
        fill: "281549",
        r: 40,
        g: 21,
        b: 73,
      },
    ];

    const deer = [
      {
        x1: 316.31569,
        y1: 784.43208,
        x2: 21.52679,
        y2: -26.56999,
        x3: -24.3312,
        y3: -1.47314,
        d: "m 316.31569,784.43208 21.52679,-26.56999 -24.3312,-1.47314",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 337.10591,
        y1: 758.15672,
        x2: -24.3312,
        y2: -40.33192,
        x3: 0.73657,
        y3: 38.56415,
        d: "m 337.10591,758.15672 -24.3312,-40.33192 0.73657,38.56415",
        fill: "23256e",
        r: 35,
        g: 37,
        b: 110,
      },
      {
        x1: 328.5011,
        y1: 744.12196,
        x2: 12.25125,
        y2: -52.6307,
        x3: -27.97764,
        y3: 26.33354,
        d: "m 328.5011,744.12196 12.25125,-52.6307 -27.97764,26.33354",
        fill: "440f48",
        r: 68,
        g: 15,
        b: 72,
      },
      {
        x1: 340.75235,
        y1: 691.49126,
        x2: 19.6299,
        y2: -48.07313,
        x3: -28.84425,
        y3: 6.40994,
        d: "m 340.75235,691.49126 19.6299,-48.07313 -28.84425,6.40994",
        fill: "8a1d55",
        r: 138,
        g: 29,
        b: 85,
      },
      {
        x1: 312.77471,
        y1: 717.8248,
        x2: 18.76329,
        y2: -67.99673,
        x3: 9.21435,
        y3: 41.66319,
        d: "m 312.77471,717.8248 18.76329,-67.99673 9.21435,41.66319",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 360.38225,
        y1: 643.41813,
        x2: 43.66554,
        y2: -32.84988,
        x3: -72.50979,
        y3: 39.25982,
        d: "m 360.38225,643.41813 43.66554,-32.84988 -72.50979,39.25982",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 404.04779,
        y1: 610.56825,
        x2: -49.67444,
        y2: 4.40666,
        x3: -22.83535,
        y3: 34.85316,
        d: "m 404.04779,610.56825 -49.67444,4.40666 -22.83535,34.85316",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 354.37335,
        y1: 614.97491,
        x2: 58.08766,
        y2: -59.68992,
        x3: -8.41322,
        y3: 55.28326,
        d: "m 354.37335,614.97491 58.08766,-59.68992 -8.41322,55.28326",
        fill: "880046",
        r: 136,
        g: 0,
        b: 70,
      },
      {
        x1: 404.04779,
        y1: 610.56825,
        x2: 95.54237,
        y2: -44.86769,
        x3: -87.12915,
        y3: -10.41557,
        d: "m 404.04779,610.56825 95.54237,-44.86769 -87.12915,-10.41557",
        fill: "b01419",
        r: 176,
        g: 20,
        b: 25,
      },
      {
        x1: 499.59016,
        y1: 565.70056,
        x2: 98.35147,
        y2: -4.40666,
        x3: -53.68101,
        y3: -54.08204,
        d: "m 499.59016,565.70056 98.35147,-4.40666 -53.68101,-54.08204",
        fill: "a61217",
        r: 166,
        g: 18,
        b: 23,
      },
      {
        x1: 412.46101,
        y1: 555.28499,
        x2: 131.79961,
        y2: -48.07313,
        x3: -44.67046,
        y3: 58.4887,
        d: "m 412.46101,555.28499 131.79961,-48.07313 -44.67046,58.4887",
        fill: "d91920",
        r: 217,
        g: 25,
        b: 32,
      },
      {
        x1: 392.50614,
        y1: 575.79022,
        x2: -68.17826,
        y2: -99.82505,
        x3: 88.13313,
        y3: 79.31982,
        d: "m 392.50614,575.79022 -68.17826,-99.82505 88.13313,79.31982",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 362.8833,
        y1: 510.66525,
        x2: 181.37732,
        y2: -3.45339,
        x3: -131.79961,
        y3: 48.07313,
        d: "m 362.8833,510.66525 181.37732,-3.45339 -131.79961,48.07313",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 324.32788,
        y1: 475.96517,
        x2: 35.25325,
        y2: -9.21434,
        x3: 3.30217,
        y3: 43.91442,
        d: "m 324.32788,475.96517 35.25325,-9.21434 3.30217,43.91442",
        fill: "f79210",
        r: 247,
        g: 146,
        b: 16,
      },
      {
        x1: 359.58113,
        y1: 466.75083,
        x2: 36.06189,
        y2: 43.2908,
        x3: -32.75972,
        y3: 0.62362,
        d: "m 359.58113,466.75083 36.06189,43.2908 -32.75972,0.62362",
        fill: "f57c14",
        r: 245,
        g: 124,
        b: 20,
      },
      {
        x1: 544.26062,
        y1: 507.21186,
        x2: 58.08766,
        y2: -40.46103,
        x3: -4.40665,
        y3: 94.54307,
        d: "m 544.26062,507.21186 58.08766,-40.46103 -4.40665,94.54307",
        fill: "ed114e",
        r: 237,
        g: 17,
        b: 78,
      },
      {
        x1: 597.94163,
        y1: 561.2939,
        x2: 50.07547,
        y2: 94.94411,
        x3: 22.43432,
        y3: -122.18518,
        d: "m 597.94163,561.2939 50.07547,94.94411 22.43432,-122.18518",
        fill: "7d0f6b",
        r: 125,
        g: 15,
        b: 107,
      },
      {
        x1: 654.92762,
        y1: 618.59922,
        x2: 27.14152,
        y2: 55.66551,
        x3: -34.05204,
        y3: -18.02672,
        d: "m 654.92762,618.59922 27.14152,55.66551 -34.05204,-18.02672",
        fill: "281549",
        r: 40,
        g: 21,
        b: 73,
      },
      {
        x1: 648.0171,
        y1: 656.23801,
        x2: -4.40666,
        y2: 65.69881,
        x3: 38.4587,
        y3: -47.67209,
        d: "m 648.0171,656.23801 -4.40666,65.69881 38.4587,-47.67209",
        fill: "23256e",
        r: 35,
        g: 37,
        b: 110,
      },
      {
        x1: 682.06914,
        y1: 674.26473,
        x2: -31.24763,
        y2: 88.13313,
        x3: -7.21107,
        y3: -40.46104,
        d: "m 682.06914,674.26473 -31.24763,88.13313 -7.21107,-40.46104",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 643.61044,
        y1: 721.93682,
        x2: -21.23216,
        y2: 59.69085,
        x3: 28.44323,
        y3: -19.22981,
        d: "m 643.61044,721.93682 -21.23216,59.69085 28.44323,-19.22981",
        fill: "0e5f9d",
        r: 14,
        g: 95,
        b: 157,
      },
      {
        x1: 650.82151,
        y1: 762.39786,
        x2: -17.04213,
        y2: 39.51638,
        x3: -11.4011,
        y3: -20.28657,
        d: "m 650.82151,762.39786 -17.04213,39.51638 -11.4011,-20.28657",
        fill: "0085bc",
        r: 0,
        g: 133,
        b: 188,
      },
      {
        x1: 622.37828,
        y1: 781.62767,
        x2: -20.83112,
        y2: 24.03657,
        x3: 32.23222,
        y3: -3.75,
        d: "m 622.37828,781.62767 -20.83112,24.03657 32.23222,-3.75",
        fill: "26b9f1",
        r: 38,
        g: 185,
        b: 241,
      },
      {
        x1: 670.45142,
        y1: 534.05283,
        x2: -68.10314,
        y2: -67.302,
        x3: -4.40665,
        y3: 94.54307,
        d: "m 670.45142,534.05283 -68.10314,-67.302 -4.40665,94.54307",
        fill: "851f77",
        r: 133,
        g: 31,
        b: 119,
      },
      {
        x1: 670.45142,
        y1: 534.05283,
        x2: 14.82222,
        y2: -69.50533,
        x3: -82.92536,
        y3: 2.20333,
        d: "m 670.45142,534.05283 14.82222,-69.50533 -82.92536,2.20333",
        fill: "70174e",
        r: 112,
        g: 23,
        b: 78,
      },
      {
        x1: 670.45142,
        y1: 534.05283,
        x2: 22.33382,
        y2: -41.5627,
        x3: -7.5116,
        y3: -27.94263,
        d: "m 670.45142,534.05283 22.33382,-41.5627 -7.5116,-27.94263",
        fill: "281549",
        r: 40,
        g: 21,
        b: 73,
      },
      {
        x1: 685.27364,
        y1: 603.05759,
        x2: 38.15721,
        y2: 48.07219,
        x3: -55.5838,
        y3: -16.22443,
        d: "m 685.27364,603.05759 38.15721,48.07219 -55.5838,-16.22443",
        fill: "2744a0",
        r: 39,
        g: 68,
        b: 160,
      },
      {
        x1: 723.43085,
        y1: 651.12978,
        x2: -5.10729,
        y2: 69.40484,
        x3: -22.68414,
        y3: -77.51658,
        d: "m 723.43085,651.12978 -5.10729,69.40484 -22.68414,-77.51658",
        fill: "125582",
        r: 18,
        g: 85,
        b: 130,
      },
      {
        x1: 667.84705,
        y1: 634.90535,
        x2: 40.18116,
        y2: 50.44833,
        x3: -12.38879,
        y3: -42.33564,
        d: "m 667.84705,634.90535 40.18116,50.44833 -12.38879,-42.33564",
        fill: "005e8a",
        r: 0,
        g: 94,
        b: 138,
      },
      {
        x1: 685.27364,
        y1: 603.05759,
        x2: -14.82222,
        y2: -69.00476,
        x3: -12.66961,
        y3: 69.00476,
        d: "m 685.27364,603.05759 -14.82222,-69.00476 -12.66961,69.00476",
        fill: "0e3463",
        r: 14,
        g: 52,
        b: 99,
      },
      {
        x1: 657.78181,
        y1: 603.05759,
        x2: 10.06524,
        y2: 31.84776,
        x3: 17.42659,
        y3: -31.84776,
        d: "m 657.78181,603.05759 10.06524,31.84776 17.42659,-31.84776",
        fill: "084673",
        r: 8,
        g: 70,
        b: 115,
      },
      {
        x1: 692.78524,
        y1: 492.49013,
        x2: -17.77314,
        y2: 62.79486,
        x3: -4.56068,
        y3: -21.23216,
        d: "m 692.78524,492.49013 -17.77314,62.79486 -4.56068,-21.23216",
        fill: "0f354c",
        r: 15,
        g: 53,
        b: 76,
      },
      {
        x1: 685.27364,
        y1: 464.5475,
        x2: -72.4093,
        y2: -56.18488,
        x3: -10.51606,
        y3: 58.38821,
        d: "m 685.27364,464.5475 -72.4093,-56.18488 -10.51606,58.38821",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 685.27364,
        y1: 464.5475,
        x2: -23.13495,
        y2: -35.4533,
        x3: -49.27435,
        y3: -20.73158,
        d: "m 685.27364,464.5475 -23.13495,-35.4533 -49.27435,-20.73158",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 612.86434,
        y1: 408.36262,
        x2: -100.35194,
        y2: 10.21552,
        x3: 89.83588,
        y3: 48.17269,
        d: "m 612.86434,408.36262 -100.35194,10.21552 89.83588,48.17269",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 544.26062,
        y1: 507.21186,
        x2: -31.74822,
        y2: -88.63372,
        x3: 89.83588,
        y3: 48.17269,
        d: "m 544.26062,507.21186 -31.74822,-88.63372 89.83588,48.17269",
        fill: "ba151b",
        r: 186,
        g: 21,
        b: 27,
      },
      {
        x1: 395.64302,
        y1: 510.04163,
        x2: 127.31031,
        y2: -62.31494,
        x3: 21.30729,
        y3: 59.48517,
        d: "m 395.64302,510.04163 127.31031,-62.31494 21.30729,59.48517",
        fill: "f14a54",
        r: 241,
        g: 74,
        b: 84,
      },
      {
        x1: 457.96077,
        y1: 479.53877,
        x2: 54.55163,
        y2: -60.96063,
        x3: 10.44093,
        y3: 29.14855,
        d: "m 457.96077,479.53877 54.55163,-60.96063 10.44093,29.14855",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 359.58113,
        y1: 466.75083,
        x2: 98.37964,
        y2: 12.78794,
        x3: -62.31775,
        y3: 30.50286,
        d: "m 359.58113,466.75083 98.37964,12.78794 -62.31775,30.50286",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 512.5124,
        y1: 418.57814,
        x2: -112.37068,
        y2: -4.50715,
        x3: 57.81905,
        y3: 65.46778,
        d: "m 512.5124,418.57814 -112.37068,-4.50715 57.81905,65.46778",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 400.14172,
        y1: 414.07099,
        x2: -40.56059,
        y2: 52.67984,
        x3: 98.37964,
        y3: 12.78794,
        d: "m 400.14172,414.07099 -40.56059,52.67984 98.37964,12.78794",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 359.58113,
        y1: 466.75083,
        x2: -10.21552,
        y2: -36.45541,
        x3: 50.77611,
        y3: -16.22443,
        d: "m 359.58113,466.75083 -10.21552,-36.45541 50.77611,-16.22443",
        fill: "cce310",
        r: 204,
        g: 227,
        b: 16,
      },
      {
        x1: 400.14172,
        y1: 414.07099,
        x2: -14.12065,
        y2: -78.11766,
        x3: -36.65546,
        y3: 94.34209,
        d: "m 400.14172,414.07099 -14.12065,-78.11766 -36.65546,94.34209",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 349.36561,
        y1: 430.29542,
        x2: -25.03773,
        y2: 45.66975,
        x3: 35.25325,
        y3: -9.21434,
        d: "m 349.36561,430.29542 -25.03773,45.66975 35.25325,-9.21434",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 324.32788,
        y1: 475.96517,
        x2: -13.7215,
        y2: -50.17596,
        x3: 38.75923,
        y3: 4.50621,
        d: "m 324.32788,475.96517 -13.7215,-50.17596 38.75923,4.50621",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 310.60638,
        y1: 425.78921,
        x2: 58.56289,
        y2: -46.46431,
        x3: -19.80366,
        y3: 50.97052,
        d: "m 310.60638,425.78921 58.56289,-46.46431 -19.80366,50.97052",
        fill: "fff200",
        r: 255,
        g: 242,
        b: 0,
      },
      {
        x1: 310.60638,
        y1: 425.78921,
        x2: 13.7215,
        y2: -38.75924,
        x3: 44.84139,
        y3: -7.70507,
        d: "m 310.60638,425.78921 13.7215,-38.75924 44.84139,-7.70507",
        fill: "bfdf14",
        r: 191,
        g: 223,
        b: 20,
      },
      {
        x1: 699.39522,
        y1: 473.5618,
        x2: -6.60998,
        y2: 18.92833,
        x3: -7.5116,
        y3: -27.94263,
        d: "m 699.39522,473.5618 -6.60998,18.92833 -7.5116,-27.94263",
        fill: "132b37",
        r: 19,
        g: 43,
        b: 55,
      },
      {
        x1: 699.39522,
        y1: 473.5618,
        x2: 0.625,
        y2: 55.6033,
        x3: -7.23498,
        y3: -36.67497,
        d: "m 699.39522,473.5618 0.625,55.6033 -7.23498,-36.67497",
        fill: "632d46",
        r: 99,
        g: 45,
        b: 70,
      },
      {
        x1: 680.34103,
        y1: 536.45621,
        x2: 19.67919,
        y2: -7.29111,
        x3: -7.23498,
        y3: -36.67497,
        d: "m 680.34103,536.45621 19.67919,-7.29111 -7.23498,-36.67497",
        fill: "4f1942",
        r: 79,
        g: 25,
        b: 66,
      },
      {
        x1: 700.02022,
        y1: 529.1651,
        x2: 12.29443,
        y2: 28.52327,
        x3: -31.97362,
        y3: -21.23216,
        d: "m 700.02022,529.1651 12.29443,28.52327 -31.97362,-21.23216",
        fill: "851132",
        r: 133,
        g: 17,
        b: 50,
      },
      {
        x1: 386.02107,
        y1: 335.95333,
        x2: -32.44979,
        y2: -36.956,
        x3: 32.81437,
        y3: 5.98287,
        d: "m 386.02107,335.95333 -32.44979,-36.956 32.81437,5.98287",
        fill: "0f868e",
        r: 15,
        g: 134,
        b: 142,
      },
      {
        x1: 324.32788,
        y1: 387.02997,
        x2: -3.23406,
        y2: -30.2869,
        x3: 48.07545,
        y3: 22.58183,
        d: "m 324.32788,387.02997 -3.23406,-30.2869 48.07545,22.58183",
        fill: "a6d71c",
        r: 166,
        g: 215,
        b: 28,
      },
      {
        x1: 321.09382,
        y1: 356.74307,
        x2: 64.92725,
        y2: -20.78974,
        x3: -16.8518,
        y3: 43.37157,
        d: "m 321.09382,356.74307 64.92725,-20.78974 -16.8518,43.37157",
        fill: "59c134",
        r: 89,
        g: 193,
        b: 52,
      },
      {
        x1: 321.09382,
        y1: 356.74307,
        x2: 32.47746,
        y2: -57.74574,
        x3: 32.44979,
        y3: 36.956,
        d: "m 321.09382,356.74307 32.47746,-57.74574 32.44979,36.956",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 321.09382,
        y1: 356.74307,
        x2: -23.10633,
        y2: 2.94628,
        x3: 55.58379,
        y3: -60.69202,
        d: "m 321.09382,356.74307 -23.10633,2.94628 55.58379,-60.69202",
        fill: "05768d",
        r: 5,
        g: 118,
        b: 141,
      },
      {
        x1: 319.62068,
        y1: 304.10462,
        x2: 33.9506,
        y2: -5.10729,
        x3: -39.77731,
        y3: 43.43262,
        d: "m 319.62068,304.10462 33.9506,-5.10729 -39.77731,43.43262",
        fill: "3c63b8",
        r: 60,
        g: 99,
        b: 184,
      },
      {
        x1: 297.98749,
        y1: 359.68935,
        x2: 26.34039,
        y2: 27.34062,
        x3: -3.23406,
        y3: -30.2869,
        d: "m 297.98749,359.68935 26.34039,27.34062 -3.23406,-30.2869",
        fill: "00a770",
        r: 0,
        g: 167,
        b: 112,
      },
      {
        x1: 297.98749,
        y1: 359.68935,
        x2: -8.11174,
        y2: 19.63555,
        x3: 34.45213,
        y3: 7.70507,
        d: "m 297.98749,359.68935 -8.11174,19.63555 34.45213,7.70507",
        fill: "59c134",
        r: 89,
        g: 193,
        b: 52,
      },
      {
        x1: 324.32788,
        y1: 387.02997,
        x2: -23.0354,
        y2: 4.80769,
        x3: -11.41673,
        y3: -12.51276,
        d: "m 324.32788,387.02997 -23.0354,4.80769 -11.41673,-12.51276",
        fill: "73c82c",
        r: 115,
        g: 200,
        b: 44,
      },
      {
        x1: 313.79397,
        y1: 342.42995,
        x2: -9.79758,
        y2: -21.71584,
        x3: 15.62429,
        y3: -16.60949,
        d: "m 313.79397,342.42995 -9.79758,-21.71584 15.62429,-16.60949",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 305.31783,
        y1: 351.68562,
        x2: 2.57243,
        y2: -22.34228,
        x3: 5.90371,
        y3: 13.08661,
        d: "m 305.31783,351.68562 2.57243,-22.34228 5.90371,13.08661",
        fill: "4dc6f4",
        r: 77,
        g: 198,
        b: 244,
      },
      {
        x1: 386.38565,
        y1: 304.9802,
        x2: 25.17374,
        y2: -22.80837,
        x3: 46.87098,
        y3: -4.20661,
        d: "m 386.38565,304.9802 25.17374,-22.80837 46.87098,-4.20661",
        fill: "005d4f",
        r: 0,
        g: 93,
        b: 79,
      },
      {
        x1: 458.43037,
        y1: 277.96522,
        x2: -15.32281,
        y2: 34.25208,
        x3: -56.72191,
        y3: -7.2371,
        d: "m 458.43037,277.96522 -15.32281,34.25208 -56.72191,-7.2371",
        fill: "0f868e",
        r: 15,
        g: 134,
        b: 142,
      },
      {
        x1: 443.10756,
        y1: 312.2173,
        x2: -57.08649,
        y2: 11.05045,
        x3: 0.36458,
        y3: -18.28755,
        d: "m 443.10756,312.2173 -57.08649,11.05045 0.36458,-18.28755",
        fill: "0799b5",
        r: 7,
        g: 153,
        b: 181,
      },
      {
        x1: 319.62068,
        y1: 304.10462,
        x2: -19.22982,
        y2: -19.22888,
        x3: -45.06774,
        y3: -5.10729,
        d: "m 319.62068,304.10462 -19.22982,-19.22888 -45.06774,-5.10729",
        fill: "005d28",
        r: 0,
        g: 93,
        b: 40,
      },
      {
        x1: 303.99639,
        y1: 320.71411,
        x2: -48.67327,
        y2: -40.94566,
        x3: 64.29756,
        y3: 24.33617,
        d: "m 303.99639,320.71411 -48.67327,-40.94566 64.29756,24.33617",
        fill: "0b686e",
        r: 11,
        g: 104,
        b: 110,
      },
      {
        x1: 255.32312,
        y1: 279.76845,
        x2: 18.6278,
        y2: 29.74494,
        x3: 30.04547,
        y3: 11.20072,
        d: "m 255.32312,279.76845 18.6278,29.74494 30.04547,11.20072",
        fill: "0799b5",
        r: 7,
        g: 153,
        b: 181,
      },
      {
        x1: 377.90839,
        y1: 279.76845,
        x2: -8.11174,
        y2: 22.23333,
        x3: -16.22537,
        y3: -3.00445,
        d: "m 377.90839,279.76845 -8.11174,22.23333 -16.22537,-3.00445",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 369.79665,
        y1: 302.00178,
        x2: 34.25114,
        y2: -24.03656,
        x3: -26.1394,
        y3: 1.80323,
        d: "m 369.79665,302.00178 34.25114,-24.03656 -26.1394,1.80323 -8.11174,22.23333",
        fill: "ec0677",
        r: 236,
        g: 6,
        b: 119,
      },
      {
        x1: 386.92175,
        y1: 289.98397,
        x2: 24.63764,
        y2: -7.81214,
        x3: -7.5116,
        y3: -4.20661,
        d: "m 386.92175,289.98397 24.63764,-7.81214 -7.5116,-4.20661 -17.12604,12.01875",
        fill: "a0148e",
        r: 160,
        g: 20,
        b: 142,
      },
      {
        x1: 404.04779,
        y1: 277.96522,
        x2: 40.34056,
        y2: -19.73857,
        x3: -32.82896,
        y3: 23.94518,
        d: "m 404.04779,277.96522 40.34056,-19.73857 -32.82896,23.94518 -7.5116,-4.20661",
        fill: "6e126b",
        r: 110,
        g: 18,
        b: 107,
      },
      {
        x1: 411.55939,
        y1: 282.17183,
        x2: 37.85762,
        y2: -16.22442,
        x3: -5.02866,
        y3: -7.72076,
        d: "m 411.55939,282.17183 37.85762,-16.22442 -5.02866,-7.72076",
        fill: "a11971",
        r: 161,
        g: 25,
        b: 113,
      },
      {
        x1: 449.41701,
        y1: 265.94741,
        x2: 22.83441,
        y2: -33.04993,
        x3: -27.86307,
        y3: 25.32917,
        d: "m 449.41701,265.94741 22.83441,-33.04993 -27.86307,25.32917",
        fill: "ec047c",
        r: 236,
        g: 4,
        b: 124,
      },
      {
        x1: 444.38835,
        y1: 258.22665,
        x2: 0.22097,
        y2: -30.73794,
        x3: 13.82105,
        y3: 18.47847,
        d: "m 444.38835,258.22665 0.22097,-30.73794 13.82105,18.47847",
        fill: "8d0e5c",
        r: 141,
        g: 14,
        b: 92,
      },
      {
        x1: 444.60932,
        y1: 227.48871,
        x2: -40.56153,
        y2: -21.33171,
        x3: 40.56153,
        y3: 30.34601,
        d: "m 444.60932,227.48871 -40.56153,-21.33171 40.56153,30.34601",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 472.25142,
        y1: 232.89748,
        x2: 6.0089,
        y2: -48.37367,
        x3: -13.45007,
        y3: 55.41004,
        d: "m 472.25142,232.89748 6.0089,-48.37367 -13.45007,55.41004",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 452.99624,
        y1: 238.70164,
        x2: 10.54142,
        y2: -21.12791,
        x3: -18.92834,
        y3: 9.91498,
        d: "m 452.99624,238.70164 10.54142,-21.12791 -18.92834,9.91498",
        fill: "6e126b",
        r: 110,
        g: 18,
        b: 107,
      },
      {
        x1: 463.53766,
        y1: 217.57373,
        x2: 4.20661,
        y2: -26.74048,
        x3: -13.67078,
        y3: 31.69844,
        d: "m 463.53766,217.57373 4.20661,-26.74048 -13.67078,31.69844",
        fill: "bd0c8d",
        r: 189,
        g: 12,
        b: 141,
      },
      {
        x1: 467.74427,
        y1: 190.83325,
        x2: -6.83539,
        y2: -42.36382,
        x3: 0.8199,
        y3: 56.31166,
        d: "m 467.74427,190.83325 -6.83539,-42.36382 0.8199,56.31166",
        fill: "ec047c",
        r: 236,
        g: 4,
        b: 124,
      },
      {
        x1: 461.72878,
        y1: 204.78109,
        x2: -14.71609,
        y2: -13.94784,
        x3: 14.71609,
        y3: 6.97439,
        d: "m 461.72878,204.78109 -14.71609,-13.94784 14.71609,6.97439",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 377.90839,
        y1: 279.76845,
        x2: -3.15472,
        y2: -36.50518,
        x3: -4.95702,
        y3: 42.91418,
        d: "m 377.90839,279.76845 -3.15472,-36.50518 -4.95702,42.91418",
        fill: "a6083d",
        r: 166,
        g: 8,
        b: 61,
      },
      {
        x1: 337.39664,
        y1: 301.43076,
        x2: -43.61576,
        y2: -44.19711,
        x3: 30.547,
        y3: 46.16282,
        d: "m 337.39664,301.43076 -43.61576,-44.19711 30.547,46.16282",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 293.78088,
        y1: 257.23365,
        x2: -10.55738,
        y2: -1.50834,
        x3: 33.52046,
        y3: 36.21123,
        d: "m 293.78088,257.23365 -10.55738,-1.50834 33.52046,36.21123",
        fill: "23256e",
        r: 35,
        g: 37,
        b: 110,
      },
      {
        x1: 330.04188,
        y1: 293.97833,
        x2: -4.26202,
        y2: -55.27669,
        x3: -7.38857,
        y3: 43.47019,
        d: "m 330.04188,293.97833 -4.26202,-55.27669 -7.38857,43.47019",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 293.78088,
        y1: 257.23365,
        x2: -1.35417,
        y2: -71.50768,
        x3: -9.20321,
        y3: 69.99934,
        d: "m 293.78088,257.23365 -1.35417,-71.50768 -9.20321,69.99934",
        fill: "47165e",
        r: 71,
        g: 22,
        b: 94,
      },
      {
        x1: 293.78088,
        y1: 231.99586,
        x2: 25.8398,
        y2: -32.14831,
        x3: -25.8398,
        y3: 17.72618,
        d: "m 293.78088,231.99586 25.8398,-32.14831 -25.8398,17.72618",
        fill: "a11971",
        r: 161,
        g: 25,
        b: 113,
      },
      {
        x1: 292.42671,
        y1: 185.72597,
        x2: -11.26472,
        y2: -24.63765,
        x3: 7.24957,
        y3: 60.24122,
        d: "m 292.42671,185.72597 -11.26472,-24.63765 7.24957,60.24122",
        fill: "ec086d",
        r: 236,
        g: 8,
        b: 109,
      },
      {
        x1: 287.77349,
        y1: 175.62768,
        x2: 25.53774,
        y2: -40.37822,
        x3: -20.88452,
        y3: 50.47651,
        d: "m 287.77349,175.62768 25.53774,-40.37822 -20.88452,50.47651",
        fill: "84085c",
        r: 132,
        g: 8,
        b: 92,
      },
      {
        x1: 283.2235,
        y1: 255.72531,
        x2: -34.8109,
        y2: -39.8036,
        x3: 35.76135,
        y3: 33.50073,
        d: "m 283.2235,255.72531 -34.8109,-39.8036 35.76135,33.50073",
        fill: "ec0772",
        r: 236,
        g: 7,
        b: 114,
      },
      {
        x1: 248.4126,
        y1: 215.92171,
        x2: 5.70837,
        y2: -54.83339,
        x3: 1.34773,
        y3: 61.44337,
        d: "m 248.4126,215.92171 5.70837,-54.83339 1.34773,61.44337",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 260.76101,
        y1: 227.48871,
        x2: 16.19437,
        y2: -44.16612,
        x3: -8.09672,
        y3: 51.75192,
        d: "m 260.76101,227.48871 16.19437,-44.16612 -8.09672,51.75192",
        fill: "7a1d90",
        r: 122,
        g: 29,
        b: 144,
      },
      {
        x1: 453.57196,
        y1: 587.31215,
        x2: -5.05657,
        y2: 86.55248,
        x3: -36.05438,
        y3: -67.24659,
        d: "m 453.57196,587.31215 -5.05657,86.55248 -36.05438,-67.24659",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 452.37638,
        y1: 607.77887,
        x2: 15.36789,
        y2: 63.28136,
        x3: -19.22888,
        y3: 2.8044,
        d: "m 452.37638,607.77887 15.36789,63.28136 -19.22888,2.8044",
        fill: "4e155e",
        r: 78,
        g: 21,
        b: 94,
      },
      {
        x1: 467.74427,
        y1: 671.06023,
        x2: -2.40338,
        y2: 70.10641,
        x3: -16.8255,
        y3: -67.30201,
        d: "m 467.74427,671.06023 -2.40338,70.10641 -16.8255,-67.30201",
        fill: "7e1355",
        r: 126,
        g: 19,
        b: 85,
      },
      {
        x1: 467.74427,
        y1: 671.06023,
        x2: 15.22325,
        y2: 74.51306,
        x3: -17.62663,
        y3: -4.40665,
        d: "m 467.74427,671.06023 15.22325,74.51306 -17.62663,-4.40665",
        fill: "a11971",
        r: 161,
        g: 25,
        b: 113,
      },
      {
        x1: 482.96752,
        y1: 745.57329,
        x2: -8.81332,
        y2: 48.0722,
        x3: -8.81331,
        y3: -52.47885,
        d: "m 482.96752,745.57329 -8.81332,48.0722 -8.81331,-52.47885",
        fill: "ba0a42",
        r: 186,
        g: 10,
        b: 66,
      },
      {
        x1: 448.51539,
        y1: 793.64549,
        x2: 20.39253,
        y2: -31.24106,
        x3: 5.24628,
        y3: 31.24106,
        d: "m 448.51539,793.64549 20.39253,-31.24106 5.24628,31.24106",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 722.44846,
        y1: 664.48311,
        x2: 27.87314,
        y2: 91.35548,
        x3: -31.99804,
        y3: -35.30397,
        d: "m 722.44846,664.48311 27.87314,91.35548 -31.99804,-35.30397",
        fill: "005e8a",
        r: 0,
        g: 94,
        b: 138,
      },
      {
        x1: 718.32356,
        y1: 720.53462,
        x2: 8.56255,
        y2: 41.86324,
        x3: 23.43549,
        y3: -6.55927,
        d: "m 718.32356,720.53462 8.56255,41.86324 23.43549,-6.55927",
        fill: "0085bc",
        r: 0,
        g: 133,
        b: 188,
      },
      {
        x1: 750.3216,
        y1: 755.83859,
        x2: -20.73063,
        y2: 37.40681,
        x3: -2.70486,
        y3: -30.84754,
        d: "m 750.3216,755.83859 -20.73063,37.40681 -2.70486,-30.84754",
        fill: "33bdf2",
        r: 51,
        g: 189,
        b: 242,
      },
      {
        x1: 729.59097,
        y1: 793.2454,
        x2: -25.53336,
        y2: 2.35702,
        x3: 22.8285,
        y3: -33.20456,
        d: "m 729.59097,793.2454 -25.53336,2.35702 22.8285,-33.20456",
        fill: "0799b5",
        r: 7,
        g: 153,
        b: 181,
      },
    ];

    const wolf = [
      {
        x1: 674.95451,
        y1: 398.25836,
        x2: -4.52794,
        y2: 113.20848,
        x3: -25.35875,
        y3: 31.24548,
        d: "m 674.95451,398.25836 -4.52794,113.20848 -25.35875,31.24548",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 645.06782,
        y1: 542.71232,
        x2: -37.2838,
        y2: 53.6255,
        x3: -28.83029,
        y3: -33.24787,
        d: "m 645.06782,542.71232 -37.2838,53.6255 -28.83029,-33.24787",
        fill: "2744a0",
        r: 39,
        g: 68,
        b: 160,
      },
      {
        x1: 641.44472,
        y1: 691.2426,
        x2: -33.6607,
        y2: -94.90478,
        x3: 27.32078,
        y3: 31.50747,
        d: "m 641.44472,691.2426 -33.6607,-94.90478 27.32078,31.50747",
        fill: "127bca",
        r: 18,
        g: 123,
        b: 202,
      },
      {
        x1: 578.95373,
        y1: 563.08995,
        x2: 25.74409,
        y2: 81.26566,
        x3: 3.0862,
        y3: -48.01779,
        d: "m 578.95373,563.08995 25.74409,81.26566 3.0862,-48.01779",
        fill: "0076a8",
        r: 0,
        g: 118,
        b: 168,
      },
      {
        x1: 602.50136,
        y1: 679.46841,
        x2: 23.38434,
        y2: -32.09357,
        x3: 15.55902,
        y3: 43.86776,
        d: "m 602.50136,679.46841 23.38434,-32.09357 15.55902,43.86776",
        fill: "26b9f1",
        r: 38,
        g: 185,
        b: 241,
      },
      {
        x1: 625.8857,
        y1: 647.37484,
        x2: -18.10168,
        y2: -51.03702,
        x3: -4.83027,
        y3: 57.31938,
        d: "m 625.8857,647.37484 -18.10168,-51.03702 -4.83027,57.31938",
        fill: "153a75",
        r: 21,
        g: 58,
        b: 117,
      },
      {
        x1: 602.95375,
        y1: 653.6572,
        x2: 22.93195,
        y2: -6.28236,
        x3: -23.38434,
        y3: 32.09357,
        d: "m 602.95375,653.6572 22.93195,-6.28236 -23.38434,32.09357",
        fill: "0076a8",
        r: 0,
        g: 118,
        b: 168,
      },
      {
        x1: 650.95448,
        y1: 712.52582,
        x2: -48.45312,
        y2: -33.05741,
        x3: 38.94336,
        y3: 11.77419,
        d: "m 650.95448,712.52582 -48.45312,-33.05741 38.94336,11.77419",
        fill: "153a75",
        r: 21,
        g: 58,
        b: 117,
      },
      {
        x1: 632.16185,
        y1: 731.5447,
        x2: 18.79263,
        y2: -19.01888,
        x3: -48.45312,
        y3: -33.05741,
        d: "m 632.16185,731.5447 18.79263,-19.01888 -48.45312,-33.05741",
        fill: "0e5f9d",
        r: 14,
        g: 95,
        b: 157,
      },
      {
        x1: 673.59578,
        y1: 716.14817,
        x2: -41.43393,
        y2: 15.39653,
        x3: 18.79263,
        y3: -19.01888,
        d: "m 673.59578,716.14817 -41.43393,15.39653 18.79263,-19.01888",
        fill: "1c63b7",
        r: 28,
        g: 99,
        b: 183,
      },
      {
        x1: 680.38879,
        y1: 729.50732,
        x2: -30.63912,
        y2: -4.49762,
        x3: 23.84611,
        y3: -8.86153,
        d: "m 680.38879,729.50732 -30.63912,-4.49762 23.84611,-8.86153",
        fill: "0f354c",
        r: 15,
        g: 53,
        b: 76,
      },
      {
        x1: 680.38879,
        y1: 729.50732,
        x2: -30.63912,
        y2: -4.49762,
        x3: -17.58782,
        y3: 6.535,
        d: "m 680.38879,729.50732 -30.63912,-4.49762 -17.58782,6.535",
        fill: "162429",
        r: 22,
        g: 36,
        b: 41,
      },
      {
        x1: 651.63392,
        y1: 602.03408,
        x2: -6.5661,
        y2: -59.32176,
        x3: 21.32366,
        y3: -26.27369,
        d: "m 651.63392,602.03408 -6.5661,-59.32176 21.32366,-26.27369",
        fill: "291639",
        r: 41,
        g: 22,
        b: 57,
      },
      {
        x1: 635.1048,
        y1: 627.84529,
        x2: 9.96302,
        y2: -85.13297,
        x3: 6.5661,
        y3: 59.32176,
        d: "m 635.1048,627.84529 9.96302,-85.13297 6.5661,59.32176",
        fill: "422256",
        r: 66,
        g: 34,
        b: 86,
      },
      {
        x1: 652.87916,
        y1: 679.46841,
        x2: -17.77436,
        y2: -51.62312,
        x3: 16.52912,
        y3: -25.81121,
        d: "m 652.87916,679.46841 -17.77436,-51.62312 16.52912,-25.81121",
        fill: "2e1449",
        r: 46,
        g: 20,
        b: 73,
      },
      {
        x1: 641.44472,
        y1: 691.2426,
        x2: -6.33992,
        y2: -63.39731,
        x3: 17.77436,
        y3: 51.62312,
        d: "m 641.44472,691.2426 -6.33992,-63.39731 17.77436,51.62312",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 662.72792,
        y1: 705.50658,
        x2: -21.2832,
        y2: -14.26398,
        x3: 11.43444,
        y3: -11.77419,
        d: "m 662.72792,705.50658 -21.2832,-14.26398 11.43444,-11.77419",
        fill: "331249",
        r: 51,
        g: 18,
        b: 73,
      },
      {
        x1: 650.95448,
        y1: 712.52582,
        x2: -9.50976,
        y2: -21.28322,
        x3: 21.2832,
        y3: 14.26398,
        d: "m 650.95448,712.52582 -9.50976,-21.28322 21.2832,14.26398",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 675.86012,
        y1: 703.46919,
        x2: -13.1322,
        y2: 2.03739,
        x3: -2.22082,
        y3: -5.87274,
        d: "m 675.86012,703.46919 -13.1322,2.03739 -2.22082,-5.87274",
        fill: "70174e",
        r: 112,
        g: 23,
        b: 78,
      },
      {
        x1: 684.23736,
        y1: 712.52582,
        x2: -21.50944,
        y2: -7.01924,
        x3: 13.1322,
        y3: -2.03739,
        d: "m 684.23736,712.52582 -21.50944,-7.01924 13.1322,-2.03739",
        fill: "891551",
        r: 137,
        g: 21,
        b: 81,
      },
      {
        x1: 673.59578,
        y1: 716.14817,
        x2: -10.86786,
        y2: -10.64159,
        x3: 21.50944,
        y3: 7.01924,
        d: "m 673.59578,716.14817 -10.86786,-10.64159 21.50944,7.01924",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 662.72792,
        y1: 705.50658,
        x2: 10.86786,
        y2: 10.64159,
        x3: -22.6413,
        y3: -3.62235,
        d: "m 662.72792,705.50658 10.86786,10.64159 -22.6413,-3.62235",
        fill: "2e1449",
        r: 46,
        g: 20,
        b: 73,
      },
      {
        x1: 662.27552,
        y1: 459.54211,
        x2: -17.2077,
        y2: 83.17021,
        x3: -66.11409,
        y3: 20.37763,
        d: "m 662.27552,459.54211 -17.2077,83.17021 -66.11409,20.37763",
        fill: "186fa8",
        r: 24,
        g: 111,
        b: 168,
      },
      {
        x1: 607.78402,
        y1: 443.3908,
        x2: 54.4915,
        y2: 16.15131,
        x3: -83.32179,
        y3: 103.54784,
        d: "m 607.78402,443.3908 54.4915,16.15131 -83.32179,103.54784",
        fill: "0e5f8d",
        r: 14,
        g: 95,
        b: 141,
      },
      {
        x1: 607.78402,
        y1: 443.3908,
        x2: 54.4915,
        y2: 16.15131,
        x3: 6.28414,
        y3: -28.7282,
        d: "m 607.78402,443.3908 54.4915,16.15131 6.28414,-28.7282",
        fill: "104680",
        r: 16,
        g: 70,
        b: 128,
      },
      {
        x1: 669.21861,
        y1: 352.82354,
        x2: -61.43459,
        y2: 90.56726,
        x3: 67.17049,
        y3: -45.13244,
        d: "m 669.21861,352.82354 -61.43459,90.56726 67.17049,-45.13244",
        fill: "7641a4",
        r: 118,
        g: 65,
        b: 164,
      },
      {
        x1: 451.25433,
        y1: 539.99557,
        x2: 99.01991,
        y2: -53.73672,
        x3: -27.77395,
        y3: -39.24567,
        d: "m 451.25433,539.99557 99.01991,-53.73672 -27.77395,-39.24567",
        fill: "4dc18d",
        r: 77,
        g: 193,
        b: 141,
      },
      {
        x1: 550.27424,
        y1: 486.25885,
        x2: -27.77395,
        y2: -39.24567,
        x3: 39.93851,
        y3: -1.29698,
        d: "m 550.27424,486.25885 -27.77395,-39.24567 39.93851,-1.29698",
        fill: "246a8b",
        r: 36,
        g: 106,
        b: 139,
      },
      {
        x1: 550.27424,
        y1: 486.25885,
        x2: 57.50978,
        y2: -42.86805,
        x3: -28.83029,
        y3: 119.69915,
        d: "m 550.27424,486.25885 57.50978,-42.86805 -28.83029,119.69915",
        fill: "0076a8",
        r: 0,
        g: 118,
        b: 168,
      },
      {
        x1: 534.06173,
        y1: 667.15887,
        x2: 44.892,
        y2: -104.06892,
        x3: 15.87852,
        y3: 49.75678,
        d: "m 534.06173,667.15887 44.892,-104.06892 15.87852,49.75678",
        fill: "0b686e",
        r: 11,
        g: 104,
        b: 110,
      },
      {
        x1: 548.26332,
        y1: 634.27614,
        x2: 30.69041,
        y2: -71.18619,
        x3: -28.67949,
        y3: -76.8311,
        d: "m 548.26332,634.27614 30.69041,-71.18619 -28.67949,-76.8311",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 385.44187,
        y1: 622.10938,
        x2: 77.28426,
        y2: -50.07392,
        x3: -11.4718,
        y3: -32.03989,
        d: "m 385.44187,622.10938 77.28426,-50.07392 -11.4718,-32.03989",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 517.77027,
        y1: 612.84673,
        x2: -27.52207,
        y2: -49.75678,
        x3: -27.52207,
        y3: 8.94551,
        d: "m 517.77027,612.84673 -27.52207,-49.75678 -27.52207,8.94551",
        fill: "d9e70c",
        r: 217,
        g: 231,
        b: 12,
      },
      {
        x1: 451.25433,
        y1: 539.99557,
        x2: 11.4718,
        y2: 32.03989,
        x3: 27.52207,
        y3: -8.94551,
        d: "m 451.25433,539.99557 11.4718,32.03989 27.52207,-8.94551",
        fill: "fff533",
        r: 255,
        g: 245,
        b: 51,
      },
      {
        x1: 550.27424,
        y1: 486.25885,
        x2: -99.01991,
        y2: 53.73672,
        x3: 38.99387,
        y3: 23.09438,
        d: "m 550.27424,486.25885 -99.01991,53.73672 38.99387,23.09438",
        fill: "33b540",
        r: 51,
        g: 181,
        b: 64,
      },
      {
        x1: 490.2482,
        y1: 563.08995,
        x2: 60.02604,
        y2: -76.8311,
        x3: -2.01092,
        y3: 148.01729,
        d: "m 490.2482,563.08995 60.02604,-76.8311 -2.01092,148.01729",
        fill: "0f868e",
        r: 15,
        g: 134,
        b: 142,
      },
      {
        x1: 518.79794,
        y1: 647.28474,
        x2: -56.07181,
        y2: -75.24928,
        x3: 55.04414,
        y3: 40.81127,
        d: "m 518.79794,647.28474 -56.07181,-75.24928 55.04414,40.81127",
        fill: "b3db18",
        r: 179,
        g: 219,
        b: 24,
      },
      {
        x1: 548.26332,
        y1: 634.27614,
        x2: -58.01512,
        y2: -71.18619,
        x3: 27.52207,
        y3: 49.75678,
        d: "m 548.26332,634.27614 -58.01512,-71.18619 27.52207,49.75678",
        fill: "00a880",
        r: 0,
        g: 168,
        b: 128,
      },
      {
        x1: 492.31922,
        y1: 669.92268,
        x2: -29.59309,
        y2: -97.88722,
        x3: 56.07181,
        y3: 75.24928,
        d: "m 492.31922,669.92268 -29.59309,-97.88722 56.07181,75.24928",
        fill: "fff200",
        r: 255,
        g: 242,
        b: 0,
      },
      {
        x1: 520.08514,
        y1: 699.63384,
        x2: 28.17818,
        y2: -65.3577,
        x3: -30.49305,
        y3: -21.42941,
        d: "m 520.08514,699.63384 28.17818,-65.3577 -30.49305,-21.42941",
        fill: "59c134",
        r: 89,
        g: 193,
        b: 52,
      },
      {
        x1: 502.27344,
        y1: 711.16706,
        x2: 16.5245,
        y2: -63.88232,
        x3: 1.2872,
        y3: 52.3491,
        d: "m 502.27344,711.16706 16.5245,-63.88232 1.2872,52.3491",
        fill: "fff426",
        r: 255,
        g: 244,
        b: 38,
      },
      {
        x1: 502.27344,
        y1: 711.16706,
        x2: 16.5245,
        y2: -63.88232,
        x3: -49.73269,
        y3: 41.24111,
        d: "m 502.27344,711.16706 16.5245,-63.88232 -49.73269,41.24111",
        fill: "fcd205",
        r: 252,
        g: 210,
        b: 5,
      },
      {
        x1: 427.99446,
        y1: 661.27298,
        x2: 7.60067,
        y2: -17.71031,
        x3: 33.47012,
        y3: 44.96318,
        d: "m 427.99446,661.27298 7.60067,-17.71031 33.47012,44.96318",
        fill: "f68712",
        r: 246,
        g: 135,
        b: 18,
      },
      {
        x1: 427.99446,
        y1: 661.27298,
        x2: 7.60067,
        y2: -17.71031,
        x3: -50.15326,
        y3: -21.45329,
        d: "m 427.99446,661.27298 7.60067,-17.71031 -50.15326,-21.45329",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 424.08362,
        y1: 711.16706,
        x2: 44.98163,
        y2: -22.64121,
        x3: 26.83801,
        y3: 18.29826,
        d: "m 424.08362,711.16706 44.98163,-22.64121 26.83801,18.29826",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 528.2768,
        y1: 729.36377,
        x2: -59.21155,
        y2: 3.23732,
        x3: 26.83801,
        y3: -25.77698,
        d: "m 528.2768,729.36377 -59.21155,3.23732 26.83801,-25.77698",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 350.52944,
        y1: 722.90595,
        x2: 43.05133,
        y2: -57.77673,
        x3: 10.57837,
        y3: 56.60407,
        d: "m 350.52944,722.90595 43.05133,-57.77673 10.57837,56.60407",
        fill: "c4161d",
        r: 196,
        g: 22,
        b: 29,
      },
      {
        x1: 424.08362,
        y1: 711.16706,
        x2: 71.81964,
        y2: -4.34295,
        x3: -26.83801,
        y3: 25.77698,
        d: "m 424.08362,711.16706 71.81964,-4.34295 -26.83801,25.77698",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 424.08362,
        y1: 711.16706,
        x2: -10.86191,
        y2: 21.08261,
        x3: 55.84354,
        y3: 0.35142,
        d: "m 424.08362,711.16706 -10.86191,21.08261 55.84354,0.35142",
        fill: "b01419",
        r: 176,
        g: 20,
        b: 25,
      },
      {
        x1: 413.22171,
        y1: 732.24967,
        x2: 10.86191,
        y2: -21.08261,
        x3: -19.92448,
        y3: 10.56623,
        d: "m 413.22171,732.24967 10.86191,-21.08261 -19.92448,10.56623",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 413.22171,
        y1: 732.24967,
        x2: -9.06257,
        y2: -10.51638,
        x3: -53.6297,
        y3: 1.17266,
        d: "m 413.22171,732.24967 -9.06257,-10.51638 -53.6297,1.17266",
        fill: "e31b22",
        r: 227,
        g: 27,
        b: 34,
      },
      {
        x1: 364.61179,
        y1: 735.92183,
        x2: -14.08235,
        y2: -13.01588,
        x3: 62.69227,
        y3: 9.34372,
        d: "m 364.61179,735.92183 -14.08235,-13.01588 62.69227,9.34372",
        fill: "9c1116",
        r: 156,
        g: 17,
        b: 22,
      },
      {
        x1: 310.87512,
        y1: 724.14842,
        x2: 39.65432,
        y2: -1.24247,
        x3: 23.40097,
        y3: -66.66569,
        d: "m 310.87512,724.14842 39.65432,-1.24247 23.40097,-66.66569",
        fill: "870e12",
        r: 135,
        g: 14,
        b: 18,
      },
      {
        x1: 546.65107,
        y1: 712.3626,
        x2: -26.56593,
        y2: -12.72876,
        x3: 6.15487,
        y3: -7.146,
        d: "m 546.65107,712.3626 -26.56593,-12.72876 6.15487,-7.146",
        fill: "880534",
        r: 136,
        g: 5,
        b: 52,
      },
      {
        x1: 511.8631,
        y1: 717.82953,
        x2: 21.15369,
        y2: -1.68136,
        x3: -30.74335,
        y3: -4.98111,
        d: "m 511.8631,717.82953 21.15369,-1.68136 -30.74335,-4.98111",
        fill: "5e4435",
        r: 94,
        g: 68,
        b: 53,
      },
      {
        x1: 533.01679,
        y1: 716.14817,
        x2: -30.74335,
        y2: -4.98111,
        x3: 17.8117,
        y3: -11.53322,
        d: "m 533.01679,716.14817 -30.74335,-4.98111 17.8117,-11.53322",
        fill: "88200f",
        r: 136,
        g: 32,
        b: 15,
      },
      {
        x1: 533.01679,
        y1: 716.14817,
        x2: -12.93165,
        y2: -16.51433,
        x3: 26.56593,
        y3: 12.72876,
        d: "m 533.01679,716.14817 -12.93165,-16.51433 26.56593,12.72876",
        fill: "880a1f",
        r: 136,
        g: 10,
        b: 31,
      },
      {
        x1: 537.59448,
        y1: 756.14868,
        x2: -93.88803,
        y2: 15.09494,
        x3: 25.3588,
        y3: -38.64253,
        d: "m 537.59448,756.14868 -93.88803,15.09494 25.3588,-38.64253",
        fill: "23256e",
        r: 35,
        g: 37,
        b: 110,
      },
      {
        x1: 520.26083,
        y1: 769.48649,
        x2: -76.55438,
        y2: 1.75713,
        x3: 93.88803,
        y3: -15.09494,
        d: "m 520.26083,769.48649 -76.55438,1.75713 93.88803,-15.09494",
        fill: "17194a",
        r: 23,
        g: 25,
        b: 74,
      },
      {
        x1: 443.70645,
        y1: 771.24362,
        x2: 25.3588,
        y2: -38.64253,
        x3: -55.84354,
        y3: -0.35142,
        d: "m 443.70645,771.24362 25.3588,-38.64253 -55.84354,-0.35142",
        fill: "4e155e",
        r: 78,
        g: 21,
        b: 94,
      },
      {
        x1: 340.76261,
        y1: 763.69576,
        x2: 72.4591,
        y2: -31.44609,
        x3: 30.48474,
        y3: 38.99395,
        d: "m 340.76261,763.69576 72.4591,-31.44609 30.48474,38.99395",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 340.76261,
        y1: 763.69576,
        x2: 72.4591,
        y2: -31.44609,
        x3: -48.60992,
        y3: 3.67216,
        d: "m 340.76261,763.69576 72.4591,-31.44609 -48.60992,3.67216",
        fill: "7e1355",
        r: 126,
        g: 19,
        b: 85,
      },
      {
        x1: 340.76261,
        y1: 763.69576,
        x2: 9.76683,
        y2: -40.78981,
        x3: -39.65432,
        y3: 1.24247,
        d: "m 340.76261,763.69576 9.76683,-40.78981 -39.65432,1.24247",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 350.52944,
        y1: 722.90595,
        x2: -9.76683,
        y2: 40.78981,
        x3: 23.84918,
        y3: -27.77393,
        d: "m 350.52944,722.90595 -9.76683,40.78981 23.84918,-27.77393",
        fill: "ba084a",
        r: 186,
        g: 8,
        b: 74,
      },
      {
        x1: 310.87512,
        y1: 748.14842,
        x2: 29.88749,
        y2: 15.54734,
        x3: -29.88749,
        y3: -39.54734,
        d: "m 310.87512,748.14842 29.88749,15.54734 -29.88749,-39.54734",
        fill: "9c076a",
        r: 156,
        g: 7,
        b: 106,
      },
      {
        x1: 677.97365,
        y1: 301.80443,
        x2: -66.11408,
        y2: 62.1893,
        x3: 57.35904,
        y3: -11.17019,
        d: "m 677.97365,301.80443 -66.11408,62.1893 57.35904,-11.17019",
        fill: "1e2060",
        r: 30,
        g: 32,
        b: 96,
      },
      {
        x1: 611.85957,
        y1: 363.99373,
        x2: 57.35904,
        y2: -11.17019,
        x3: -61.43459,
        y3: 90.56726,
        d: "m 611.85957,363.99373 57.35904,-11.17019 -61.43459,90.56726",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 611.85957,
        y1: 363.99373,
        x2: -49.42077,
        y2: 81.72247,
        x3: -39.93851,
        y3: 1.29698,
        d: "m 611.85957,363.99373 -49.42077,81.72247 -39.93851,1.29698",
        fill: "143e65",
        r: 20,
        g: 62,
        b: 101,
      },
      {
        x1: 533.06653,
        y1: 405.50383,
        x2: 50.66155,
        y2: -15.37473,
        x3: -61.22779,
        y3: 56.88408,
        d: "m 533.06653,405.50383 50.66155,-15.37473 -61.22779,56.88408",
        fill: "2e3192",
        r: 46,
        g: 49,
        b: 146,
      },
      {
        x1: 560.84047,
        y1: 347.08762,
        x2: 22.88761,
        y2: 43.04148,
        x3: -50.66155,
        y3: 15.37473,
        d: "m 560.84047,347.08762 22.88761,43.04148 -50.66155,15.37473",
        fill: "5e2590",
        r: 94,
        g: 37,
        b: 144,
      },
      {
        x1: 638.5017,
        y1: 338.93346,
        x2: -54.77362,
        y2: 51.19564,
        x3: -22.88761,
        y3: -43.04148,
        d: "m 638.5017,338.93346 -54.77362,51.19564 -22.88761,-43.04148",
        fill: "712090",
        r: 113,
        g: 32,
        b: 144,
      },
      {
        x1: 694.57741,
        y1: 273.12492,
        x2: -59.78323,
        y2: 41.10177,
        x3: 43.17947,
        y3: -12.42226,
        d: "m 694.57741,273.12492 -59.78323,41.10177 43.17947,-12.42226",
        fill: "593c9f",
        r: 89,
        g: 60,
        b: 159,
      },
      {
        x1: 634.79418,
        y1: 314.22669,
        x2: 43.17947,
        y2: -12.42226,
        x3: -39.47195,
        y3: 37.12903,
        d: "m 634.79418,314.22669 43.17947,-12.42226 -39.47195,37.12903",
        fill: "4b2a91",
        r: 75,
        g: 42,
        b: 145,
      },
      {
        x1: 534.57531,
        y1: 334.71026,
        x2: 38.64253,
        y2: -19.92446,
        x3: -12.37737,
        y3: 32.30182,
        d: "m 534.57531,334.71026 38.64253,-19.92446 -12.37737,32.30182",
        fill: "5c144e",
        r: 92,
        g: 20,
        b: 78,
      },
      {
        x1: 638.5017,
        y1: 338.93346,
        x2: -77.66123,
        y2: 8.15416,
        x3: 12.37737,
        y3: -32.30182,
        d: "m 638.5017,338.93346 -77.66123,8.15416 12.37737,-32.30182",
        fill: "8f1f68",
        r: 143,
        g: 31,
        b: 104,
      },
      {
        x1: 573.21784,
        y1: 314.7858,
        x2: 65.28386,
        y2: 24.14766,
        x3: -3.70752,
        y3: -24.70677,
        d: "m 573.21784,314.7858 65.28386,24.14766 -3.70752,-24.70677",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 663.18108,
        y1: 277.35125,
        x2: 31.39633,
        y2: -4.22633,
        x3: -59.78323,
        y3: 41.10177,
        d: "m 663.18108,277.35125 31.39633,-4.22633 -59.78323,41.10177",
        fill: "440f48",
        r: 68,
        g: 15,
        b: 72,
      },
      {
        x1: 691.86059,
        y1: 261.65311,
        x2: 2.71682,
        y2: 11.47181,
        x3: -19.6229,
        y3: 2.64134,
        d: "m 691.86059,261.65311 2.71682,11.47181 -19.6229,2.64134",
        fill: "ec086d",
        r: 236,
        g: 8,
        b: 109,
      },
      {
        x1: 530.6514,
        y1: 323.54008,
        x2: 38.34012,
        y2: -14.49016,
        x3: -25.40934,
        y3: 21.01657,
        d: "m 530.6514,323.54008 38.34012,-14.49016 -25.40934,21.01657",
        fill: "4b2a91",
        r: 75,
        g: 42,
        b: 145,
      },
      {
        x1: 568.99152,
        y1: 309.04992,
        x2: -25.40934,
        y2: 21.01657,
        x3: 29.63566,
        y3: -15.28069,
        d: "m 568.99152,309.04992 -25.40934,21.01657 29.63566,-15.28069",
        fill: "7e1355",
        r: 126,
        g: 19,
        b: 85,
      },
      {
        x1: 599.67106,
        y1: 268.70968,
        x2: -26.45322,
        y2: 46.07612,
        x3: -4.22632,
        y3: -5.73588,
        d: "m 599.67106,268.70968 -26.45322,46.07612 -4.22632,-5.73588",
        fill: "9c0a5f",
        r: 156,
        g: 10,
        b: 95,
      },
      {
        x1: 651.70928,
        y1: 259.53953,
        x2: -78.49144,
        y2: 55.24627,
        x3: 26.45322,
        y3: -46.07612,
        d: "m 651.70928,259.53953 -78.49144,55.24627 26.45322,-46.07612",
        fill: "600947",
        r: 96,
        g: 9,
        b: 71,
      },
      {
        x1: 634.79418,
        y1: 314.22669,
        x2: -61.57634,
        y2: 0.55911,
        x3: 78.49144,
        y3: -55.24627,
        d: "m 634.79418,314.22669 -61.57634,0.55911 78.49144,-55.24627",
        fill: "8a1d55",
        r: 138,
        g: 29,
        b: 85,
      },
      {
        x1: 663.18108,
        y1: 277.35125,
        x2: -28.3869,
        y2: 36.87544,
        x3: 16.9151,
        y3: -54.68716,
        d: "m 663.18108,277.35125 -28.3869,36.87544 16.9151,-54.68716",
        fill: "ec0677",
        r: 236,
        g: 6,
        b: 119,
      },
      {
        x1: 649.72131,
        y1: 224.94543,
        x2: 1.98797,
        y2: 34.5941,
        x3: -35.77179,
        y3: 6.30335,
        d: "m 649.72131,224.94543 1.98797,34.5941 -35.77179,6.30335",
        fill: "84085c",
        r: 132,
        g: 8,
        b: 92,
      },
      {
        x1: 663.18108,
        y1: 234.48241,
        x2: -11.4718,
        y2: 25.05712,
        x3: -1.98797,
        y3: -34.5941,
        d: "m 663.18108,234.48241 -11.4718,25.05712 -1.98797,-34.5941",
        fill: "841b8f",
        r: 132,
        g: 27,
        b: 143,
      },
      {
        x1: 663.18108,
        y1: 277.35125,
        x2: -11.4718,
        y2: -17.81172,
        x3: 11.4718,
        y3: -25.05712,
        d: "m 663.18108,277.35125 -11.4718,-17.81172 11.4718,-25.05712",
        fill: "a60c2f",
        r: 166,
        g: 12,
        b: 47,
      },
      {
        x1: 674.95451,
        y1: 263.46424,
        x2: 4.8886,
        y2: 8.22105,
        x3: 6.99831,
        y3: -5.84241,
        d: "m 674.95451,263.46424 4.8886,8.22105 6.99831,-5.84241",
        fill: "b4137a",
        r: 180,
        g: 19,
        b: 122,
      },
      {
        x1: 671.33219,
        y1: 251.08687,
        x2: -8.23455,
        y2: 1.81119,
        x3: 0.0835,
        y3: -8.62213,
        d: "m 671.33219,251.08687 -8.23455,1.81119 0.0835,-8.62213",
        fill: "ec0a68",
        r: 236,
        g: 10,
        b: 104,
      },
      {
        x1: 607.78402,
        y1: 443.3908,
        x2: 4.07555,
        y2: -79.39707,
        x3: -49.42077,
        y3: 81.72247,
        d: "m 607.78402,443.3908 4.07555,-79.39707 -49.42077,81.72247",
        fill: "0e5f8d",
        r: 14,
        g: 95,
        b: 141,
      },
      {
        x1: 550.27424,
        y1: 486.25885,
        x2: 57.50978,
        y2: -42.86805,
        x3: -45.34522,
        y3: 2.3254,
        d: "m 550.27424,486.25885 57.50978,-42.86805 -45.34522,2.3254",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 427.99446,
        y1: 661.27298,
        x2: -23.83532,
        y2: 60.46031,
        x3: -18.71727,
        y3: -99.62391,
        d: "m 427.99446,661.27298 -23.83532,60.46031 -18.71727,-99.62391",
        fill: "a60d2c",
        r: 166,
        g: 13,
        b: 44,
      },
      {
        x1: 427.99446,
        y1: 661.27298,
        x2: -23.83532,
        y2: 60.46031,
        x3: 64.90611,
        y3: -33.20744,
        d: "m 427.99446,661.27298 -23.83532,60.46031 64.90611,-33.20744",
        fill: "f03838",
        r: 240,
        g: 56,
        b: 56,
      },
      {
        x1: 534.06173,
        y1: 667.15887,
        x2: -13.97659,
        y2: 32.47497,
        x3: 74.74711,
        y3: -86.78711,
        d: "m 534.06173,667.15887 -13.97659,32.47497 74.74711,-86.78711",
        fill: "0e5f8d",
        r: 14,
        g: 95,
        b: 141,
      },
      {
        x1: 350.52944,
        y1: 722.90595,
        x2: 43.05133,
        y2: -57.77673,
        x3: -8.1389,
        y3: -43.01984,
        d: "m 350.52944,722.90595 43.05133,-57.77673 -8.1389,-43.01984",
        fill: "b01419",
        r: 176,
        g: 20,
        b: 25,
      },
      {
        x1: 451.25433,
        y1: 539.99557,
        x2: 36.23421,
        y2: -63.03829,
        x3: 35.01175,
        y3: -29.9441,
        d: "m 451.25433,539.99557 36.23421,-63.03829 35.01175,-29.9441",
        fill: "00abb7",
        r: 0,
        g: 171,
        b: 183,
      },
      {
        x1: 385.44187,
        y1: 622.10938,
        x2: 34.26442,
        y2: -51.2366,
        x3: 31.54804,
        y3: -30.87721,
        d: "m 385.44187,622.10938 34.26442,-51.2366 31.54804,-30.87721",
        fill: "f68712",
        r: 246,
        g: 135,
        b: 18,
      },
      {
        x1: 492.31922,
        y1: 669.92268,
        x2: -29.59309,
        y2: -97.88722,
        x3: 6.33912,
        y3: 116.49039,
        d: "m 492.31922,669.92268 -29.59309,-97.88722 6.33912,116.49039",
        fill: "f9a72b",
        r: 249,
        g: 167,
        b: 43,
      },
      {
        x1: 645.06782,
        y1: 542.71232,
        x2: -37.2838,
        y2: 53.6255,
        x3: 27.32078,
        y3: 31.50747,
        d: "m 645.06782,542.71232 -37.2838,53.6255 27.32078,31.50747",
        fill: "0e5f8d",
        r: 14,
        g: 95,
        b: 141,
      },
      {
        x1: 607.78402,
        y1: 443.3908,
        x2: 67.17049,
        y2: -45.13244,
        x3: -6.39485,
        y3: 32.55555,
        d: "m 607.78402,443.3908 67.17049,-45.13244 -6.39485,32.55555",
        fill: "143e65",
        r: 20,
        g: 62,
        b: 101,
      },
      {
        x1: 462.72613,
        y1: 572.03546,
        x2: -27.131,
        y2: 71.52721,
        x3: -50.15326,
        y3: -21.45329,
        d: "m 462.72613,572.03546 -27.131,71.52721 -50.15326,-21.45329",
        fill: "f25c19",
        r: 242,
        g: 92,
        b: 25,
      },
      {
        x1: 462.72613,
        y1: 572.03546,
        x2: -27.131,
        y2: 71.52721,
        x3: 33.47012,
        y3: 44.96318,
        d: "m 462.72613,572.03546 -27.131,71.52721 33.47012,44.96318",
        fill: "f7971d",
        r: 247,
        g: 151,
        b: 29,
      },
    ];

    function shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }

    const svg = document.querySelector("svg");
    const paths = [];
    cat.forEach((item, i) => {
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      svg.appendChild(path);
      path.setAttribute("d", item.d);
      path.setAttribute("style", `fill:#${item.fill}`);
      path.setAttribute("id", `path${i}`);
      path.style.transformOrigin = "50%";
      paths.push(path);
    });

    let start = null;
    const duration = 1500;

    function linear(t) {
      return t;
    }
    function cubic(t) {
      return t * t * t;
    }
    function elastic(t, coeff) {
      var p = coeff;
      return Math.pow(2, -10 * t) * Math.sin(((t - p / 4) * (2 * Math.PI)) / p) + 1;
    }

    function interpolate(v1, v2, progress, duration, easing, coeff) {
      return v1 + (v2 - v1) * easing(progress / duration, coeff);
    }

    function componentToHex(color) {
      var strHex = color.toString(16);
      return strHex.length === 1 ? "0" + strHex : strHex;
    }

    function rgbToHex(r, g, b) {
      return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }

    function animate(animal) {
      start = null;
      return new Promise(function (resolve, reject) {
        window.requestAnimationFrame(step);

        function step(timestamp) {
          if (!start) start = timestamp;
          let progress = timestamp - start;
          if (progress > duration) progress = duration;

          animal.forEach((item, i) => {
            const from = prevAnimal[i],
              to = animal[i];
            let descr = "m ",
              fill = "";
            for (let j = 1; j <= 3; j++) {
              const x = `x${j}`;
              const y = `y${j}`;
              const valueX = interpolate(from[x], to[x], progress, duration, elastic, 0.9);
              const valueY = interpolate(from[y], to[y], progress, duration, elastic, 1.3);
              descr += `${valueX},${valueY} `;
              const r = parseInt(interpolate(from["r"], to["r"], progress, duration, cubic), 10);
              const g = parseInt(interpolate(from["g"], to["g"], progress, duration, cubic), 10);
              const b = parseInt(interpolate(from["b"], to["b"], progress, duration, cubic), 10);
              fill = rgbToHex(r, g, b);
            }
            const bump = 1 + 0.6 * Math.sin((progress / duration) * Math.PI);
            paths[i].setAttribute("d", descr);
            paths[i].style.fill = fill;
            paths[i].style.transform = `scale(${bump})`;
          });

          if (progress < duration) {
            window.requestAnimationFrame(step);
          } else {
            resolve();
          }
        }
      });
    }

    const animals = [bear, deer, cat, wolf];
    let index = 0,
      animal = bear,
      prevAnimal = cat;
    function schedule() {
      animate(animal).then(() => {
        index++;
        index %= animals.length;
        prevAnimal = animal;
        animal = animals[index];
        shuffle(animal);
        setTimeout(schedule, 2000);
      });
    }
    schedule();
  },

  methods: {},
};
</script>

<style scoped>
svg {
  /* height: 100vmin;
  width: 100vmin;
  left: calc(50% - 50vmin);
  position: absolute; */
}
</style>
